'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('homebot', ['tandibar/ng-rollbar', 'ui.router', 'homebot.directives', 'homebot.filters', 'homebot.services', 'sharedservices', 'angular-chartist', 'ngCookies', 'ngAnimate', 'ngSanitize', 'appTemplateCache']).config(['$stateProvider', '$urlRouterProvider', '$locationProvider', function ($stateProvider, $urlRouterProvider, $locationProvider) {

  $urlRouterProvider.otherwise("/");

  $stateProvider.state('homes', {
    url: '/:address/:homeId?preview&embedded',
    controller: 'HomebotCtrl',
    templateUrl: '/homes/templates/homes.html'
  }).state('homeSection', {
    url: '/:address/:homeId/:section',
    controller: 'HomebotCtrl',
    templateUrl: '/homes/templates/homes.html'
  });

  $locationProvider.html5Mode(true);
}]).constant('API_VARS', {
  path: window.HB_APP_CONFIG.API_URL + 'v1',
  app: 'HomebotWeb',
  mortgageTestData: '/test/data/mortgage-response.json',
  ratesTestData: '/test/data/rates-response.json'
}).constant('APP_CONFIG', window.HB_APP_CONFIG).config(['RollbarProvider', 'APP_CONFIG', function (RollbarProvider, APP_CONFIG) {
  if (!APP_CONFIG.ROLLBAR_ENV) return;

  RollbarProvider.init({
    accessToken: 'd601b21d78ec42e0a0d4e300c1d7933e',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: APP_CONFIG.ROLLBAR_ENV
    }
  });
}]).constant('LOANTERMS', {
  FIX30YR: '30 Year Fixed',
  FIX25YR: '25 Year Fixed',
  FIX22YR: '22 Year Fixed',
  FIX20YR: '20 Year Fixed',
  FIX15YR: '15 Year Fixed',
  FIX10YR: '10 Year Fixed',
  ARM10YR: '10/1 ARM',
  ARM7YR: '7/1 ARM',
  ARM5YR: '5/1 ARM',
  ARM3YR: '3/1 ARM',
  ARM1YR: '1/1 ARM'
}).constant('PRINCIPAL_PAYMENT_OPTIONS', Array.concat(_.range(50, 1000, 50), _.range(1000, 3000, 250), 3000))

// Add Authorization header to each request
.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AuthHeaderInterceptor');
}]).run(['FastClick', function (FastClick) {
  FastClick.attach(document.body);
}]);

angular.module('homebot').controller('HomebotCtrl', ['$scope', '$rootScope', '$stateParams', '$filter', '$location', '$timeout', '$cookies', '$window', 'AccessService', 'NotificationService', 'DataService', 'Dictionary', 'HelperService', 'ChartService', 'UtilService', 'PageNotificationService', '$sce', 'APP_CONFIG', 'SessionService', 'SSOService', function ($scope, $rootScope, $stateParams, $filter, $location, $timeout, $cookies, $window, AccessService, NotificationService, DataService, Dictionary, helpers, ChartService, utils, PageNotificationService, $sce, APP_CONFIG, SessionService, SSOService, undefined) {

  var homeId = $stateParams.homeId;
  var dictionary = new Dictionary();
  var saveTimeout;
  var hasBeenTracked = false;
  var isInitialLoad = true;

  $scope.homeUpdateStep = 0;
  $scope.homeLoadError = false;

  $scope.digestRequestLoading = false;
  $scope.sentDigestRequest = false;
  $scope.digestEmail = { value: '' };
  $scope.showAvmGraph = true;

  $scope.init = function (renew) {
    AccessService.checkAndSetLocalToken();

    $scope.getHome();
    $scope.getAvmHistory();
  };

  $scope.getHome = function () {
    DataService.getHome({}, homeId).then(function (home) {
      $scope.setCachedValues(home);
      $scope.homeLoaded = true;
      $scope.activeView = 'main';
      $scope.agent = home.agent[0];

      if ($scope.home && isInitialLoad) {
        $scope.doPageloadActions();
        isInitialLoad = false;
      }
    }).catch(function (err) {
      $scope.homeLoadError = true;

      if (err && err.status === 401) {
        $scope.homeLoadErrorType = 'access';
        utils.track('HomeAccessDenied');
      } else {
        $scope.homeLoadErrorType = 'failure';
        utils.track('HomeLoadFailed');
      }

      utils.trackException('Get Home', helpers.parseAPIError(err));
    });
  };

  $scope.getAvmHistory = function () {
    return DataService.avmHistory(homeId).then(function (history) {
      $scope.showAvmGraph = history.valuationCount > 3;
      $scope.avmHistory = history;
    });
  };

  $scope.requestEmail = function () {
    if ($scope.sentDigestRequest) {
      return;
    }

    $scope.digestRequestLoading = true;
    DataService.getHomeEmail({ email: $scope.digestEmail.value }, homeId).then(function () {
      $scope.sentDigestRequest = true;
      $scope.digestRequestLoading = false;
    });
  };

  function getSourceAndEvent() {
    var from = $location.search().f;
    if (from === 't') return { source: 'twilio', event: 'view' };else if (from === 'email') return { source: 'mandrill', event: 'view' };else return { source: 'user', event: 'view' };
  };

  $scope.setCachedValues = function (home) {
    $scope.isUpdating = true;
    $scope.home = home;

    $scope.home.answers = $scope.home.answers || {};

    $scope.home.currentLoans = helpers.sortByLoanType($scope.lookup('currentLoans'));
    $scope.home.currentLoansNoHelocs = helpers.sortByLoanType($scope.lookup('currentLoansNoHelocs'));

    $scope.home.expiredLoans = helpers.sortByDate($scope.lookup('expiredLoans'), 'date');

    $scope.showAvmDiffWarning = dictionary.showAvmDiffWarning($scope.home);

    $scope.showNonDisclosureStateWarning = dictionary.showNonDisclosureStateWarning($scope.home);

    $scope.showRefiSection = !dictionary.hasRecentLoan({ loans: $scope.home.currentLoansNoHelocs });

    $scope.showCashoutRefi = dictionary.showCashoutRefi($scope.home);

    $scope.showBuyingPowerSection = dictionary.showBuyingPowerSection($scope.home);

    $scope.showPmiSection = function () {
      return dictionary.showPmiSection($scope.home);
    };

    $scope.showReverseMortgageSection = dictionary.showReverseMortgageSection($scope.home);

    $scope.cmaDone = dictionary.cmaDone($scope.home);

    $scope.cmaSourceAgent = dictionary.cmaSourceAgent($scope.home);

    $scope.showAvmGraph = dictionary.avmWithoutCMA($scope.home);

    $scope.showAgentPreviewDigestBar = SessionService.isAgent() && Helpers.isFalsey($stateParams.embedded);

    $scope.user = $scope.getCurrentUser();

    $scope.address = $scope.home.address;
    $scope.homeLoaded = true;

    if (SessionService.isAgent()) $scope.initVideoRecorder();

    _.defer(function () {
      $scope.isUpdating = false;
    });
  };

  $scope.getNotifications = function () {
    return NotificationService.getNotifications($scope.user, $scope.home.id).then(function (results) {
      $scope.notifications = results;
      $scope.dataCount = _.filter(results, function (result) {
        return !result.is_seen;
      }).length;
    }).catch(function (error) {
      return error;
    });
  };

  $scope.listenForNewNotifications = function () {
    var userHomeTokens = _.where($scope.user.notification_tokens, { 'home_ref': homeId });
    if (userHomeTokens.length > 0) {
      var client = window.stream.connect(APP_CONFIG.GETSTREAM_API_KEY, null, APP_CONFIG.GETSTREAM_API_APP);
      var userFeed = client.feed('user_home', $scope.user.id + '_' + homeId, userHomeTokens[0].token_value);
      userFeed.subscribe(notificationCallback);
    }
  };

  function notificationCallback(data) {
    $timeout(function () {
      _.each(data.new, function (notification) {
        var newNotification = {
          activities: [notification],
          is_seen: false,
          verb: notification.verb
        };
        $scope.notifications.unshift(newNotification);
        $scope.dataCount += 1;
      });
    });
  };

  // These depend on user and home information being set in scope
  $scope.doPageloadActions = function () {
    recordPageView();

    if ($location.search().unsubscribe) $scope.unsubscribe();

    $scope.getNotifications();
    $scope.listenForNewNotifications();
  };

  function recordPageView() {
    if (SessionService.isAgent()) return;

    var user = $scope.getCurrentUser();

    //track event
    var trackEvent = _.merge({ homeId: homeId, userId: user.id, agentId: $scope.home.agentId }, getSourceAndEvent());

    DataService.trackHome(trackEvent).then(function () {
      $location.search('f', null);
    });
  };

  $scope.getDisclaimer = function () {
    return $sce.trustAsHtml($scope.home.agent[0].office.brokerage.disclaimer_html);
  };

  $scope.getCurrentUser = function () {
    var currentUser;

    //TODO: This should be reworked in api to send out token links
    // Currently we have first three chars of first_name in ?u url param
    if ($location.search().u) {
      currentUser = _.filter($scope.home.users, function (user) {
        var urlFirstThree = $location.search().u.toLowerCase();
        var userFirst = user.first_name ? user.first_name.toLowerCase() : '';

        if (userFirst && userFirst.indexOf(urlFirstThree) === 0) return true;
      })[0];
    }

    return currentUser || $scope.home.users[0];
  };

  $scope.saveInput = function (args) {
    if (!args) return;
    $scope.hasSaved = true;
    $scope.saving = true;
    $scope.saveError = false;

    DataService.saveHome(args, homeId).then(function success(home) {
      $scope.setInitialValues(home);
      $scope.saving = false;
    }, function error(err) {
      $scope.saveError = err;
      //TODO add a retry on save if 401
      utils.trackException('Save Input Error', err);
    });
  };

  $scope.lookup = function (prop, args, home) {
    home = home || $scope.home;
    return dictionary[prop](home, args);
  };

  $scope.activeViewIs = function (view) {
    return $scope.activeView === view;
  };

  $scope.changeView = function (view) {
    $scope.activeView = view;
  };

  // Used for setting view values
  // You can't set anything inside of $scope.home with it
  $scope.set = function (prop, val) {
    $scope[prop] = val;
  };

  $scope.increment = function (prop, val) {
    $scope[prop] = Math.floor(parseInt($scope[prop], 10)) + 1;
  };

  $scope.toggle = function (prop) {
    $scope[prop] = !$scope[prop];
  };

  $scope.unsubscribe = function () {
    var user = $scope.getCurrentUser();
    DataService.emailSubscribe.unsubscribe($scope.user.id).then(function (user) {
      PageNotificationService.success('You have been unsubscribed.');
      $scope.refresh();
    }).catch(function (e) {
      PageNotificationService.error('There was an error unsubscribing. Please email support@homebot.ai');
    });
  };

  $scope.showMortgageList = function () {
    $rootScope.subView = 'number-entry';
  };

  $scope.showEditMortgage = function (mortgage) {
    $scope.addMortgage = false;
    $scope.currentEditMortgage = _.cloneDeep(mortgage);
    $scope.mortgageModal = true;
  };

  $scope.showAddMortgage = function () {
    $scope.addMortgage = true;
    $scope.currentEditMortgage = false;
    $scope.mortgageModal = true;
  };

  $scope.toggleHomePaidInFull = function () {
    $scope.home.answers.isHomePaidInFull = true;
  };

  $scope.refreshAndCloseMortgageModal = function () {
    $scope.refresh();
    $scope.mortgageModal = false;
  };

  $scope.closeMortgageModal = function () {
    $scope.mortgageModal = false;
  };

  $scope.closeDisclaimerModal = function () {
    $scope.disclaimerModal = false;
  };

  $rootScope.$on('openDisclaimerModal', function () {
    $scope.disclaimerModal = true;
  });

  $scope.closeCmaSection = function () {
    $scope.cmaSectionOpen = false;
  };

  $scope.confirmLoan = function (loan) {
    loan.rate = loan.rate || loan.rateEstimated;
    loan.termYears = loan.termYears || loan.termYearsEstimated;

    DataService.confirmLoan(loan, loan.id).then(function () {
      $scope.refresh();
    });
  };

  $scope.refresh = function () {
    $scope.getHome();
  };

  $scope.showCmaSection = function () {
    $scope.cmaSectionOpen = true;
  };

  $scope.showBombBombHelpModal = function () {
    if (!$window.localStorage.getItem('hasSeenBombBombHelpModal')) {
      $window.localStorage.setItem('hasSeenBombBombHelpModal', true);
      $scope.bombBombHelpModal = true;
    } else {
      $scope.bombBombHelpModal = false;
    }
  };

  $scope.closeBombBombHelpModal = function () {
    $scope.bombBombHelpModal = false;
  };

  $scope.closeAvmDiffWarningModal = function () {
    $scope.avmDiffWarningModal = false;
  };

  $scope.closeNonDisclosureStateModal = function () {
    $scope.nonDisclosureStateModal = false;
  };

  $scope.initVideoRecorder = function () {
    SSOService.lockboxWhoami('providers').then(function (user) {
      if (!user || !user.data || !user.data.included) return false;
      try {
        if (user.data.included.length > 0) {
          var bbProvider = user.data.included.find(function (el) {
            return el.attributes.name == "bomb_bomb";
          });
          $scope.videoRecorderApiKey = bbProvider.attributes["api-key"];
          $scope.showBombBombHelpModal();
        }
      } catch (e) {
        return false;
      }
    }).catch(function () {
      return false;
    });
  };

  $scope.date = moment().format('MMMM Do, YYYY');

  $scope.init();
}]);

angular.module('homebot.directives', []).directive('helpLink', function () {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs, undefined) {

      el.on('click', function (e) {
        var $target = $(el.attr('href'));

        $target.toggleClass('open');

        e.preventDefault();
      });
    }
  };
}).directive('focusInput', function () {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs, undefined) {
      attrs.$observe('focusInput', function (newVal) {
        if (newVal === "true") $(el).find('input').first().focus();
      });
    }
  };
}).directive('changeSubView', ['$rootScope', function ($rootScope) {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      var subView = attrs.changeSubView || 'number-entry';
      el.on('click', function (e) {
        $rootScope.$apply(function () {
          $rootScope.subView = subView;
        });
        e.stopPropagation();
        e.preventDefault();
      }).addClass('linked');
    }
  };
}]).directive('subView', ['$rootScope', function ($rootScope) {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      var thisView = attrs.subView;

      $rootScope.$watch('subView', changeView);

      el.on('click', function () {
        if ($rootScope.subView === thisView) return;

        $rootScope.$apply(function () {
          $rootScope.subView = thisView;
        });
      });

      function changeView(newView, oldView, scroll) {
        if (newView === oldView) return;

        if (newView !== thisView) return el.removeClass('active');

        el.addClass('active');

        $rootScope.subView = thisView;

        if (typeof scroll !== 'undefined' && scroll !== false) $('html, body').animate({ scrollTop: $(el[0]).offset().top - 50 }, 600);
      }

      if (typeof attrs.isDefaultSubView !== 'undefined') changeView(thisView, null, false);
    }
  };
}]).directive('yearSelector', function () {
  return {
    restrict: 'A',
    template: function template() {
      var html = '<option value=""></option>';
      var year = parseInt(moment().format('YYYY'));

      for (var i = year; i > year - 30; i--) {
        html += '<option value="' + i + '">' + i + '</option>';
      }

      return html;
    }
  };
}).directive('yearSelectorShort', function () {
  return {
    restrict: 'A',
    template: function template() {
      var html = '<option value=""></option>';
      var year = parseInt(moment().format('YYYY'));

      for (var i = year; i > year - 3; i--) {
        html += '<option value="' + i + '">' + i + '</option>';
      }

      return html;
    }
  };
}).directive('monthSelector', function () {
  return {
    restrict: 'A',
    template: function template() {
      var html = '<option value=""></option>';
      var months = moment.months();

      for (var i = 0; i < months.length; i++) {
        html += '<option value="' + months[i] + '">' + months[i] + '</option>';
      }

      return html;
    }
  };
}).directive('diySelector', ['$filter', 'PRINCIPAL_PAYMENT_OPTIONS', function ($filter, PRINCIPAL_PAYMENT_OPTIONS) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function (val) {
        return parseInt(val, 10);
      });
      ngModel.$formatters.push(function (val) {
        return '' + val;
      });
    },
    template: function template() {
      var html = '';
      var values = PRINCIPAL_PAYMENT_OPTIONS.slice();

      _.each(values, function (val) {
        html += '<option value="' + val + '">' + $filter('money')(val) + '</option>';
      });

      return html;
    }
  };
}]).directive('nightlyRoomSelector', ['$filter', function ($filter) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function (val) {
        return parseInt(val, 10);
      });
      ngModel.$formatters.push(function (val) {
        return '' + val;
      });
    },
    template: function template() {
      var html = '';
      var values = [50, 75, 100, 125, 150, 200, 250, 300, 350, 400, 450, 500];

      _.each(values, function (val) {
        html += '<option value="' + val + '">' + $filter('money')(val) + '/ngt</option>';
      });

      return html;
    }
  };
}]).directive('nightlyHomeSelector', ['$filter', function ($filter) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function (val) {
        return parseInt(val, 10);
      });
      ngModel.$formatters.push(function (val) {
        return '' + val;
      });
    },
    template: function template() {
      var html = '';
      var values = [50, 75, 100, 125, 150, 200, 250, 300, 350, 400, 450, 500, 600, 700, 800, 900, 1000];

      _.each(values, function (val) {
        html += '<option value="' + val + '">' + $filter('money')(val) + '/ngt</option>';
      });

      return html;
    }
  };
}]).directive('termSelector', ['LOANTERMS', function (LOANTERMS) {
  return {
    restrict: 'A',
    template: function template() {
      var html = '<option value=""></option>';
      _.each(LOANTERMS, function (v, k) {
        html += '<option value="' + k + '">' + v + '</option>';
      });

      return html;
    }
  };
}]).directive('inputFocusHelper', function () {
  return {
    restrict: 'A',
    link: function link(scope, el) {
      var $el = $(el);

      $el.find('input').on('focus', function () {
        $el.addClass('focused');
      }).on('blur', function () {
        $el.removeClass('focused');
      });
    }
  };
}).directive('coloredValue', ['HelperService', function (helpers) {
  function updateEl(el, val, compareval) {
    compareval = compareval || 0;

    if (parseFloat(val) < parseFloat(compareval)) el.addClass('text-danger');else el.addClass('text-positive');
  };

  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      var update = function update() {
        updateEl(el, attrs.coloredValue, attrs.coloredCompare);
      };

      attrs.$observe('coloredValue', update);
    }
  };
}]).directive('twoBarCompare', ['$filter', '$window', function ($filter, $window) {
  function resize(scope, el) {
    var largest = scope.barOne > scope.barTwo ? scope.barOne : scope.barTwo;
    var height = $(el).height();

    scope.barOneHeight = height / (largest / scope.barOne);
    scope.barTwoHeight = height / (largest / scope.barTwo);
  }

  function floorValsForAnimation(scope) {
    scope.barOneHeight = 0;
    scope.barTwoHeight = 0;
  }

  return {
    restrict: 'A',
    template: function template() {
      return '<div style="height:{{barOneHeight}}px"></div><div style="height:{{barTwoHeight}}px"></div>';
    },
    scope: {
      barOne: '@',
      barTwo: '@'
    },
    link: function link(scope, el, attrs) {
      var resizeBars = _.debounce(function () {
        resize(scope, el);
      }, 200);

      attrs.$observe('barOne', resizeBars);
      attrs.$observe('barTwo', resizeBars);
      $($window).on('resize', resizeBars);

      floorValsForAnimation(scope);
      resizeBars();
    }
  };
}]).directive('percentBar', [function () {
  function setPercent(scope) {
    var val = Math.abs(parseInt(scope.barval, 10));
    var compareval = Math.abs(parseInt(scope.compareval, 10));

    var largest = val > compareval ? val : compareval;

    var barpercent = Math.abs(100 / (largest / val));

    scope.barstyle = { 'width': barpercent / 2 + '%' };
  }

  return {
    restrict: 'A',
    scope: {
      barval: '@',
      compareval: '@'
    },
    template: function template(el) {
      return el.html();
    },
    link: function link(scope, el, attrs) {
      var setVals = function setVals() {
        setPercent(scope);
      };

      attrs.$observe('barval', setVals);
      attrs.$observe('compareval', setVals);

      setVals();
    }
  };
}]).directive('track', ['UtilService', function (utils) {

  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      var label = attrs.trackLabel || null;
      var eventName = attrs.track || 'UnNamedEvent';
      var eventType = el[0].nodeName === 'SELECT' ? 'change' : 'click';

      el.on(eventType, function () {
        utils.track(eventName, label);
      });
    }
  };
}]).directive('animatedNumber', ['$filter', function ($filter) {
  var decimal_places = 2;
  var decimal_factor = decimal_places === 0 ? 1 : decimal_places * 10;

  var numberSteps = {
    money: $.animateNumber.numberStepFactories.separator(','),
    percent: function percent(now, tween) {
      $(tween.elem).text((now / decimal_factor).toFixed(decimal_places));
    }
  };

  function getNumber(number, numberType) {
    if (numberType === 'percent') return number * decimal_factor;else return Math.round(number);
  }

  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      var $el = $(el);
      var numberType = attrs.animatedNumber;
      var duration = attrs.fast !== undefined ? 250 : 1000;

      attrs.$observe('num', function (newVal) {
        if (isNaN(newVal)) return;
        var num = getNumber(newVal, numberType);
        var isNegative = num < 0;

        $el.toggleClass('number-negative', isNegative);

        num = Math.abs(num);

        $el.stop().animateNumber({
          number: num,
          numberStep: numberSteps[numberType]
        }, {
          duration: duration,
          easing: 'swing',
          complete: function complete() {
            $el.prop('number', num);
          }
        });
      });
    }
  };
}]).directive('showOnScroll', function () {
  var $el, $visibleEl, winHeight, offsetTop, scrollTop;
  var rand = Math.floor(Math.random() * 10000);
  var $doc = $(document);

  var checkScroll = _.debounce(function () {
    winHeight = $(window).height();
    offsetTop = $el.offset().top;
    scrollTop = $doc.scrollTop();
    if (offsetTop - scrollTop < winHeight / 2) {
      $el.removeClass('force-closed');
      $doc.off('scroll.' + rand);
    }
  }, 200, { maxWait: 500 });

  var link = function link(scope, el, attrs) {
    $el = $(el).addClass('force-closed');
    $doc.on('scroll.' + rand, checkScroll);
  };

  return {
    restrict: 'A',
    link: link
  };
}).directive('saveInput', function () {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var model = attrs.ngModel.replace('home.', '').replace('statement.', '');
      var binding = elem[0].tagName.toLowerCase() === 'select' ? 'change' : 'keyup blur';

      elem.on(binding, function (e) {
        if (e.keyCode === 13 || e.type === 'blur' || e.type === 'change') {
          scope.checkAndSave(model, elem.val());
        }
      });
    }
  };
}).directive('heightResize', function () {
  var $el;

  var resize = _.debounce(function () {
    $el.height(function () {
      var height = 0;
      $.each($el.children().not('.ng-hide'), function () {
        height += $(this).height();
      });
      return height;
    });
  }, 50);

  var link = function link($scope, el, attrs) {
    $el = $(el);
    attrs.$observe('heightResize', resize);
    $(window).on('resize', resize);
  };

  return {
    restrict: 'A',
    link: link
  };
}).directive('loading', function () {
  return {
    restrict: 'A',
    link: function link($scope, el, attrs) {
      var isInitialLoad = true;
      var minWait = 1000;
      var startTime, currentTime;

      el.addClass('button-loading');
      $(el).wrapInner('<span>');

      function stopLoad() {
        currentTime = moment().format('x');

        _.delay(function () {
          el.removeAttr('disabled');
          el.removeClass('button-loading--activated');
        }, minWait - (currentTime - startTime));
      }

      attrs.$observe('loading', function (newVal) {
        if (newVal === 'true') {
          startTime = moment().format('x');
          el.attr('disabled', 'disabled');
          el.addClass('button-loading--activated');
        } else {
          if (!isInitialLoad) stopLoad();
        }

        isInitialLoad = false;
      });
    }
  };
}).directive('loader', function () {
  return {
    replace: true,
    restrict: 'E',
    template: '<div class="page-loader"></div>',
    link: function link($scope, el) {
      var totalDuration = 1500;
      var bars = 30;
      _.times(bars, function (i) {
        var bar = document.createElement('div');
        el[0].appendChild(bar);
        _.delay(function () {
          bar.classList.add('animated');
        }, totalDuration / bars * i);
      });
    }
  };
}).directive('checkSupport', function () {
  return {
    restrict: 'A',
    link: function link($scope, el, attrs) {
      if ('ontouchstart' in window) el.addClass('touch');
    }
  };
}).directive('slider', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    template: '<span class="slider-min">{{minLabel}}</span>' + '<div class="slider-main"></div>' + '<span class="slider-max">{{maxLabel}}</span>',
    scope: {
      ngModel: '='
    },
    link: function link($scope, el, attrs) {
      var slider = $(el).find('.slider-main')[0];
      var prepend = attrs.prepend || '';
      var append = attrs.append || '';
      var $tooltip = $('<div class="slider-tooltip"></div>');

      function minMaxClasses() {
        if (Math.round($scope.ngModel) === Math.round($scope.min)) el.addClass('slider-at-min');else if (Math.round($scope.ngModel) === Math.round($scope.max)) el.addClass('slider-at-max');else el.removeClass('slider-at-min slider-at-max');
      }

      function bindSlide() {
        slider.noUiSlider.on('update', function (values, handle, sliderVal) {
          sliderVal = Math.round(sliderVal);

          if (sliderVal === $scope.ngModel) return;

          $tooltip.html(prepend + sliderVal + append);

          $timeout(function () {
            $scope.ngModel = sliderVal;
            minMaxClasses();
          });
        });
      }

      function setup() {
        if (slider.noUiSlider) slider.noUiSlider.destroy();

        $scope.min = attrs.min ? parseInt(attrs.min, 10) : 0;
        $scope.max = attrs.max ? parseInt(attrs.max, 10) : 100;
        $scope.minLabel = attrs.minLabel || $scope.min;
        $scope.maxLabel = attrs.maxLabel || $scope.max;

        if ($scope.ngModel < $scope.min) {
          $scope.ngModel = $scope.min;
        }

        noUiSlider.create(slider, {
          start: $scope.ngModel,
          range: {
            min: $scope.min,
            max: $scope.max
          }
        });

        setupTooltip();
        bindSlide();
        minMaxClasses();
      }

      function setupTooltip() {
        $tooltip.appendTo($(slider).find('.noUi-handle')).html(prepend + $scope.ngModel + append);
      }

      function bindSettingsChange() {
        attrs.$observe('min', function (newVal) {
          if ($scope.min !== parseInt(newVal, 10)) setup();
        });

        attrs.$observe('max', function (newVal) {
          if ($scope.max !== parseInt(newVal, 10)) setup();
        });
      }

      setup();
      bindSettingsChange();
    }
  };
}]);

angular.module('homebot.filters', []).filter('titlecase', function () {
  return _.startCase;
}).filter('phone', function () {
  return function (str) {
    str = str || '';
    str = str.toString().replace(/[^0-9]/g, '');

    if (!str || str.length < 9) return '';

    if (str.slice(0, 1) === '1') str = str.slice(1);

    return str.slice(0, 3) + '-' + str.slice(3, 6) + '-' + str.slice(6);
  };
}).filter('mobile', function () {
  return function (phones) {
    if (!phones || !phones.length) return '';
    var mobile = _.filter(phones, { which: 'mobile' });
    if (!mobile || !mobile.length) return '';

    return mobile[0].number || '';
  };
}).filter('allToDashes', function () {
  return function (str) {
    return str.replace(/[^0-9A-Z]/ig, '-');
  };
}).filter('moment', function () {
  return function (datetime, format) {
    if (datetime === 'now') datetime = new Date();
    datetime = datetime || moment.invalid();
    return moment(datetime).format(format);
  };
}).filter('fromNow', function () {
  return function (datetime, format) {
    return moment(datetime).fromNow();
  };
}).filter('fromNowUTC', function () {
  return function (datetime, format) {
    return moment.utc(datetime).fromNow();
  };
}).filter('abs', function () {
  return function (val) {
    return Math.abs(val);
  };
}).filter('roundRate', function () {
  return function (val) {
    return Math.ceil(val * 8) / 8;
  };
}).filter('numberToWords', function () {
  return function (val) {
    val = parseInt(val);
    var numbers = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    return numbers[val];
  };
}).filter('stateAbbrToName', function () {
  return function (val) {
    var states = {
      "AL": "Alabama",
      "AK": "Alaska",
      "AS": "American Samoa",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DE": "Delaware",
      "DC": "District Of Columbia",
      "FL": "Florida",
      "GA": "Georgia",
      "GU": "Guam",
      "HI": "Hawaii",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "ME": "Maine",
      "MH": "Marshall Islands",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NY": "New York",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PW": "Palau",
      "PA": "Pennsylvania",
      "PR": "Puerto Rico",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VI": "Virgin Islands",
      "VA": "Virginia",
      "WA": "Washington",
      "WV": "West Virginia",
      "WI": "Wisconsin",
      "WY": "Wyoming"
    };
    return states[val];
  };
}).filter('airbnbSlug', function () {
  return function (location) {
    return _.kebabCase(location.city) + '--' + _.kebabCase(location.state);
  };
}).filter('readableTerm', ['$filter', function ($filter) {
  return function (loan) {
    if (loan.loan_type === 'HELOC') {
      return 'HELOC';
    } else if (loan.adjustable) {
      var years = loan.arm_years_initial || 5;
      return years + '/1 ARM';
    } else {
      var termYears = $filter('roundedTermYears')(loan);
      return termYears + ' Year Fixed';
    }
  };
}]).filter('roundedTermYears', [function () {
  return function (loan) {
    var termYears = loan.termYears || loan.termYearsEstimated;
    termYears = Math.round(termYears * 100) / 100; // display up to two decimals
    return termYears;
  };
}]).filter('money', ["$filter", function ($filter) {
  return function (amount) {
    var currency = $filter('currency');

    if (amount < 0) return currency(amount, '$', 0).replace('(', '-').replace(')', '');

    return currency(amount, '$', 0);
  };
}]).filter('pluralPhrase', function () {
  return function (length, str) {
    // format is 'singular|plural'
    var options = str.split('|');

    if (length === 1) // singular
      return options[0];else // zero or plural
      return options[1];
  };
}).filter('rentalQualityPhrase', function () {
  return function (percentage) {
    if (percentage < .4) return 'a basic';
    if (percentage < .75) return 'a nice';

    return 'a fancy';
  };
}).filter('notificationCopy', function () {
  var mapping = {
    'unverified_loans': 'We found loan info in public records for your home, but it\'s missing the interest rate. Confirm the details to make Homebot more accurate.',
    'no_loans': 'Do you have any loans? Homebot is more accurate when it knows your loans.',
    'refi_30': 'You may be able to do a 30-year refi with a lower rate, which could save a lot in the long run and lower your monthly payments.',
    'refi_15': 'Doing a 15-year refi could grow your wealth a lot faster. It may require a larger monthly payment, but you might be able to do it!',
    'reverse': 'You may qualify for a Reverse Mortgage to eliminate your mortgage payment and maybe even generate monthly income back to you!',
    'pmi': 'You are close to getting out of your mortgage insurance! This could be huge for you.',
    'pp_investment': 'You may have purchasing power for an investment property.',
    'pp_trade': 'It looks like you may have enough purchasing power to consider trading up to a new home!',
    'rental': 'Have you noticed how much wealth you could build by renting your home on Airbnb or VRBO?',
    'principal_pay': 'Pro tip: Even just a small additional monthly payment toward principal can often dramatically accelerate your wealth building.',
    'cash_out': 'You may have "cashout power" to do things like home improvement or high-interest debt consolidation.'
  };

  return function (verb) {
    return mapping[verb];
  };
}).filter('notificationAnchor', function () {
  var mapping = {
    'unverified_loans': 'loans',
    'refi_30': 'refi',
    'refi_15': 'refi',
    'reverse': 'reverse-mortgage',
    'pmi': 'pmi',
    'pp_investment': 'buying-power',
    'pp_trade': 'buying-power',
    'rental': 'nightly-rentals',
    'principal_pay': 'diy-refi',
    'cash_out': 'cashout',
    'no_loans': 'no-loans'
  };

  return function (verb) {
    return mapping[verb];
  };
}).filter('excludeAgentsNotFound', function () {
  return function (agents) {
    return _.filter(agents, function (agent) {
      try {
        return agent.datasources.rets.status === 'success';
      } catch (e) {
        return false;
      };
    });
  };
});

angular.module('homebot.services', []).factory('NotificationService', ['API_VARS', '$http', '$q', '$cookies', '$location', 'UtilService', 'HelperService', 'ApiHelperService', 'APP_CONFIG', function (API_VARS, $http, $q, $cookies, $location, utils, helpers, apiHelpers, APP_CONFIG) {
  var client = window.stream.connect(APP_CONFIG.GETSTREAM_API_KEY, null, APP_CONFIG.GETSTREAM_API_APP);

  var services = {
    getNotifications: function getNotifications(user, homeId) {
      var userHomeTokens = _.where(user.notification_tokens, { 'home_ref': homeId });

      if (userHomeTokens.length > 0) {
        var userFeed = client.feed('user_home', user.id + '_' + homeId, userHomeTokens[0].token_value);

        return userFeed.get({ limit: 5 }).then(function (body) {
          return body.results;
        }).catch(function (error) {
          return console.log(error);
        });
      } else {
        return $q.resolve([]);
      }
    },

    markNotificationsAsSeen: function markNotificationsAsSeen(user, homeId) {
      var userHomeTokens = _.where(user.notification_tokens, { 'home_ref': homeId });

      if (userHomeTokens.length > 0) {
        var userFeed = client.feed('user_home', user.id + '_' + homeId, userHomeTokens[0].token_value);

        return userFeed.get({ limit: 5, mark_seen: true }).then(function (body) {
          return true;
        }).catch(function (error) {
          return console.log(error);
        });
      } else {
        return $q.resolve([]);
      }
    }
  };

  return services;
}]).factory('DataService', ['API_VARS', '$http', '$q', '$cookies', '$location', 'UtilService', 'HelperService', 'ApiHelperService', function (API_VARS, $http, $q, $cookies, $location, utils, helpers, apiHelpers) {

  var services = {
    getHome: function getHome(args, homeId) {
      var args = args || {};
      args.app = API_VARS.app;

      return $http.get(API_VARS.path + '/homes/' + homeId + '/detailed/', { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleErrorButNoModify);
    },

    getHomeEmail: function getHomeEmail(args, homeId) {
      var args = args || {};
      args.app = API_VARS.app;

      return $http.post(API_VARS.path + '/homes/' + homeId + '/requestEmail', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    trackHome: function trackHome(args) {
      args.app = API_VARS.app;

      return $http.post(API_VARS.path + '/homeActivities/track/', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    saveHome: function saveHome(args, homeId, isStatement) {
      var args = args || {};

      if (isStatement) {
        args.originalLoanAmount = 0;
      } else {
        args = _.merge(args, {
          statement: {
            payment: {
              interest: 0,
              principal: 0
            }
          }
        });
      }

      return $http.put(API_VARS.path + '/homes/' + homeId, args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    saveAnswer: function saveAnswer(question, answer, homeId) {
      var args = {
        question: question,
        answer: answer
      };

      return $http.post(API_VARS.path + '/homes/' + homeId + '/addAnswer', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    saveCMARequest: function saveCMARequest(homeId, cmaBuyersAgentPreferred) {
      var args = { data: { hasRequestedCMA: new Date() } };

      // TODO: this will be combined into one api call at some point
      return $http.post(API_VARS.path + '/homes/' + homeId + '/updateHome', args).then(function () {
        if (typeof cmaBuyersAgentPreferred === 'undefined') return;
        return services.saveAnswer('cmaBuyersAgentPreferred', cmaBuyersAgentPreferred, homeId);
      });
    },

    addLoan: function addLoan(args, homeId) {
      return $http.post(API_VARS.path + '/homes/' + homeId + '/createLoan', { data: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    saveLoan: function saveLoan(loanProperties, loanId) {
      return $http.put(API_VARS.path + '/homeLoans/' + loanId + '/editLoan', { data: loanProperties }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    confirmLoan: function confirmLoan(loan, loanId) {
      var loanProperties = {
        rate: loan.rate,
        termYears: loan.termYears
      };

      return services.saveLoan(loanProperties, loanId);
    },

    deleteLoan: function deleteLoan(loanId) {
      return $http.delete(API_VARS.path + '/homes/' + homeId + '/rloans/' + loanId).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    updateRealEstateAgent: function updateRealEstateAgent(id) {
      return $http.get(API_VARS.path + '/realEstateAgents/' + id + '/updateData').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    emailSubscribe: {
      subscribe: function subscribe(userId) {
        return $http.post(API_VARS.path + '/users/' + userId + '/emailDigests/subscribe').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
      },

      unsubscribe: function unsubscribe(userId) {
        return $http.post(API_VARS.path + '/users/' + userId + '/emailDigests/unsubscribe').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
      }
    },

    avmHistory: function avmHistory(homeId) {
      return $http.get(API_VARS.path + '/homes/' + homeId + '/avmHistory/').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    addInvite: function addInvite(args) {
      return $http.post(API_VARS.path + '/invites/referral/new', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    sendMessage: function sendMessage(homeId, userId, agentId, message, topic) {
      var args = { userId: userId, agentId: agentId, message: message, topic: topic };

      return $http.post(API_VARS.path + '/homes/' + homeId + '/messageAgent/', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    sendSponsorMessage: function sendSponsorMessage(homeId, args) {

      return $http.post(API_VARS.path + '/homes/' + homeId + '/messageSponsor/', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    getRentalPotential: function getRentalPotential(homeId, args) {
      return $http.get(API_VARS.path + '/homes/' + homeId + '/rentalPotential/', { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    }

  };

  return services;
}]).factory('AccessService', ['API_VARS', '$http', '$cookies', '$location', 'ApiHelperService', 'SessionService', function (API_VARS, $http, $cookies, $location, apiHelpers, SessionService) {

  var service = {
    checkAndSetLocalToken: function checkAndSetLocalToken() {
      if (SessionService.isAgent()) return;

      var token = service.getUrlToken();

      if (!token) return;

      service.unsetUrlToken();

      service.setLocalToken(token);
    },

    getUrlToken: function getUrlToken() {
      var token = $location.search().tkn || null;
      return token;
    },

    setLocalToken: function setLocalToken(token) {
      $cookies.put('accessToken', token, { path: '/', expires: moment().add(28, 'day').format() });
    },

    unsetLocalToken: function unsetLocalToken() {
      $cookies.put('accessToken', null, { path: '/' });
      $cookies.remove('accessToken');
    },

    unsetUrlToken: function unsetUrlToken() {
      $location.search('tkn', null).replace(); // replace ensures no back button
    }
  };

  return service;
}]).factory('ChartService', ['HelperService', function (HelperService) {
  return {
    marketRate: function marketRate(history) {
      return history[0].USINTERESTRATE;
    },

    chartistRates: function chartistRates(history, userInterestRate) {
      var history = history.slice(0).reverse(); // clone array so it doesn't reverse original

      return {
        labels: _.map(history, 'WEEK'),
        series: [_.map(history, 'USINTERESTRATE'), HelperService.repeatArray(userInterestRate, history.length) // adds straight line of their rate
        ]
      };
    },

    chartistPaidSoFar: function chartistPaidSoFar(series) {
      return {
        series: series.slice(0).reverse(),
        options: {
          showLabel: false
        }
      };
    },

    chartistPaidSoFarBar: function chartistPaidSoFarBar(series) {
      return {
        labels: ['Principal', 'Interest'],
        series: series
      };
    },

    chartistBarOptions: function chartistBarOptions(series) {
      return {
        seriesBarDistance: 40,
        axisX: {
          showGrid: false,
          showLabel: false
        },
        axisY: {
          position: 'end',
          showGrid: false,
          showLabel: false
        },
        chartPadding: {
          bottom: 0,
          right: 0,
          left: 0
        },
        distributeSeries: true
      };
    }
  };
}]).factory('UtilService', ['API_VARS', function (API_VARS) {
  return {

    isValidResponse: function isValidResponse(response) {
      if (response && response.error) return false;else if (response && response.status && response.status >= 200 && response.status < 300) return true;else return false;
    },

    track: function track(eventName, label) {
      function getCategory(eventName) {
        // if events are changed on the spreadsheet,
        // they should be copy pasted directly here
        // hence the weird colons and commas on spreadsheet
        var events = {
          CallRealEstateAgent: 1,
          EmailRealEstateAgent: 1,
          EquityLearnMore: 3,
          ChangeTheseValues: 3,
          RefiLearnMore: 2,
          RefiLetsDoIt: 1,
          RefiDoYouHaveBroker: 1,
          RefiCallMortgageBroker: 1,
          ReverseMortgageCallLender: 1,
          ReverseMortgageLearnMore: 2,
          RefiEmailMortgageBroker: 1,
          PayMonthlyLearnMore: 2,
          PayMonthlyLetsDoIt: 1,
          PayMonthlyDoYouHaveBroker: 1,
          PayMonthlyCallMortgageBroker: 1,
          PayMonthlyEmailMortgageBroker: 1,
          SaveNumbers: 2,
          CashoutLearnMore: 2,
          CashoutLetsDoIt: 1,
          CashoutDoYouHaveBroker: 1,
          CashoutCallMortgageBroker: 1,
          CashoutEmailMortgageBroker: 1,
          EstimateLearnMore: 2,
          CMARequest: 1,
          CMARequestSkipped: 1,
          CMARequestFinished: 1,
          CMAQuestionAnswered: 2,
          NumbersLookRight: 3,
          NightlyCallAgent: 1,
          NightlyEmailAgent: 1,
          NightlyAirbnbClick: 1,
          NightlyVRBOClick: 1,
          NightlyAirbnbNearbyClick: 1,
          DIYUpdatePayments: 3,
          NightlyUpdatePrice: 3,
          NightlyUpdateNights: 3,
          SaveMortgage: 2,
          AddMortgage: 2,
          DeleteMortgage: 2,
          ContactSupport: "Admin3",
          PmiKnownLoaded: 1,
          PmiEstimateLoaded: 1,
          PmiLearnMore: 2,
          PmiCallMortgageBroker: 1,
          PmiEmailMortgageBroker: 1,
          BillingAddCreditCard: "Admin2",
          BillingCreditCardSubmit: "Admin1",
          BillingCreditCardCancel: "Admin3",
          BuyingPowerCallMortgageBroker: 1,
          BuyingPowerEmailMortgageBroker: 1,
          InviteAnotherHomeowner: 1,
          ContestValue: 2,
          AirDNARequest: 3,
          AirDNALoaded: 3
        };

        if (events[eventName]) return 'Category' + events[eventName];else return 'Uncategorized';
      }

      if (!eventName) {
        ga('send', 'exception', { 'exDescription': 'Tracking Error - Undefined Event' });
        return false;
      }

      var cat = getCategory(eventName);
      var label = label || null;

      ga('send', 'event', cat, eventName, label);
    },

    trackException: function trackException(errorName, description) {
      errorName = errorName || 'Uncategorized Error';
      description = description ? ' - ' + description : '';
      ga('send', 'exception', { 'exDescription': errorName + description });
    }

  };
}]).factory('ApiHelperService', ['$q', '$cookies', 'UtilService', 'HelperService', function ($q, $cookies, utils, helpers) {
  return {
    handleResponse: function handleResponse(response) {
      if (utils.isValidResponse(response)) return $q.resolve(response.data);else return $q.reject(helpers.parseAPIError(response));
    },

    handleError: function handleError(response) {
      if (response && response.status === 401) $cookies.remove('accessToken');

      return $q.reject(helpers.parseAPIError(response));
    },

    handleErrorButNoModify: function handleErrorButNoModify(response) {
      if (response && response.status === 401) $cookies.remove('accessToken');

      return $q.reject(response);
    }
  };
}]).factory('PageNotificationService', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
  var autoCloseTimeout;

  var service = {
    success: function success(message) {
      service.notify(message, 'success', true);
    },

    info: function info(message) {
      service.notify(message, 'info', true);
    },

    error: function error(message) {
      service.notify(message, 'error', false);
    },

    close: function close() {
      service.notify(null);
      service.closeListener(); // removes stateChange listener
    },

    notify: function notify(message, type, autoClose) {
      if (autoCloseTimeout) $timeout.cancel(autoCloseTimeout);

      $rootScope.$broadcast('PageNotification', {
        message: message,
        type: type
      });

      if (autoClose) autoCloseTimeout = $timeout(service.close, 5000);

      service.closeOnStateChange();
    },

    closeOnStateChange: function closeOnStateChange() {
      service.closeListener = $rootScope.$on('$stateChangeStart', service.close);
    }
  };

  return service;
}]);

// This file takes shared resources
// and injects them as angular module parts.
// Not the best way to do things, but works for now.

angular.module('sharedservices', []).factory('Dictionary', function () {
  return window.GlobalDictionary;
}).factory('ActivityDictionary', function () {
  return window.ActivityDictionary;
}).factory('HelperService', function () {
  return window.Helpers;
}).factory('LoanFormParser', function () {
  return window.LoanFormParser;
}).factory('Finance', function () {
  return window.finance;
}).factory('FastClick', function () {
  return window.FastClick;
});

if (typeof require !== 'undefined') {
  var moment = require('moment');
  var _ = require('lodash');
  var d3 = require('d3');
}

var BarChart = function () {
  function BarChart(el, options) {
    _classCallCheck(this, BarChart);

    this.el = el;
    this._buildSvg();
    this._calcDimensions();
    this._buildChartContainer();
    this._setupTips();
    var defaults = { duration: 750, verticalPaddingFactor: .1 };
    this.options = Object.assign({}, defaults, options || {});
  }

  _createClass(BarChart, [{
    key: 'update',
    value: function update(data) {
      this.datapoints = _.cloneDeep(data).datapoints;
      this.yFormat = data.yFormat;
      this._draw();
    }
  }, {
    key: '_getPaddedYDomain',
    value: function _getPaddedYDomain() {
      var min = d3.min(this.datapoints, function (d) {
        return d.value;
      });
      var max = d3.max(this.datapoints, function (d) {
        return d.value;
      });

      // give the chart some breathing room, make it less dramatic
      min -= max * this.options.verticalPaddingFactor;
      max += max * this.options.verticalPaddingFactor;

      if (min < 0) min = 0;

      return [min, max];
    }
  }, {
    key: '_buildSvg',
    value: function _buildSvg() {
      this.svg = d3.select(this.el);
    }
  }, {
    key: '_buildChartContainer',
    value: function _buildChartContainer() {
      this.chart = this.svg.append('g').attr('width', this.chartWidth).attr('height', this.chartHeight).attr('class', 'bar-chart__container').attr('transform', 'translate(' + this.margin.left + ', ' + this.margin.top + ')');
    }
  }, {
    key: '_draw',
    value: function _draw() {
      this._calcScales();
      this._drawBars();
      this._drawXAxis();
      this._drawYAxis();
    }
  }, {
    key: '_calcDimensions',
    value: function _calcDimensions() {
      this.margin = { top: 20, right: 20, bottom: 30, left: 30 };
      this.outerWidth = this.el.getBoundingClientRect().width;
      this.outerHeight = this.el.getBoundingClientRect().height;
      this.chartWidth = this.outerWidth - this.margin.left - this.margin.right;
      this.chartHeight = this.outerHeight - this.margin.top - this.margin.bottom;
    }
  }, {
    key: '_calcScales',
    value: function _calcScales() {
      this.scaleX = d3.scaleBand().range([0, this.chartWidth]).domain(this.xDomain).round(true).padding(.375);
      this.scaleY = d3.scaleLinear().domain(this._getPaddedYDomain()).range([this.chartHeight, 0]);
    }
  }, {
    key: '_drawBars',
    value: function _drawBars() {
      var _this = this;

      this.bar = this.chart.selectAll('rect').data(this.datapoints);

      this.bar.exit().remove();

      this.bar.transition().duration(this.options.duration).attr('x', function (d) {
        return _this.scaleX(d.date);
      }).attr('y', function (d) {
        return _this.scaleY(d.value);
      }).attr('width', this.scaleX.bandwidth()).attr('height', function (d) {
        return _this.chartHeight - _this.scaleY(d.value);
      });

      this.bar.enter().append('rect').on('mouseover', this.tip.show).on('mouseout', this.tip.hide).attr('class', 'bar-chart__bar').attr('x', function (d) {
        return _this.scaleX(d.date);
      }).attr('y', this.chartHeight).transition().duration(this.options.duration).attr('y', function (d) {
        return _this.scaleY(d.value);
      }).attr('width', this.scaleX.bandwidth()).attr('height', function (d) {
        return _this.chartHeight - _this.scaleY(d.value);
      });
    }
  }, {
    key: '_drawXAxis',
    value: function _drawXAxis() {
      var xAxis = d3.axisBottom(this.scaleX).tickFormat(d3.timeFormat('%b'));

      if (!this.xAxis) {
        this.xAxis = this.chart.append('g').attr('class', 'bar-chart__axis bar-chart__axis--x').attr('transform', 'translate(0, ' + this.chartHeight + ')');
      }

      this.xAxis.call(xAxis);
    }
  }, {
    key: '_drawYAxis',
    value: function _drawYAxis() {
      var format = d3.format('.2s');
      var prefix = this.yFormat === 'money' ? '$' : '';

      var yAxis = d3.axisRight(this.scaleY).tickSize(this.outerWidth).tickArguments([3]).tickFormat(function (d) {
        return prefix + format(d);
      });

      // Add to outer svg because it's outside the graph on the left
      // Prepend instead of append so that it's under the chart
      if (!this.yAxis) {
        this.yAxis = this.svg.insert('g', ':first-child').attr('class', 'bar-chart__axis bar-chart__axis--y').attr('transform', 'translate(0, ' + this.margin.top + ')');
      }

      this.yAxis.call(yAxis);

      this.yAxis.selectAll('text').attr('x', 0).attr('dy', 4); // move text down half its height to vert align center
    }
  }, {
    key: '_setupTips',
    value: function _setupTips() {
      // Workaround for tests to run
      if (!d3.tip) {
        this.tip = { show: function show() {}, hide: function hide() {} };
        return;
      }

      this.tip = d3.tip().attr('class', 'chart-tip').offset([-18, 0]).html(function (d) {
        return d.tooltipDescription + '<em>' + d.tooltipEmphasis + '</em>';
      });

      this.chart.call(this.tip);
    }
  }, {
    key: 'xDomain',
    get: function get() {
      return this.datapoints.map(function (d) {
        return d.date;
      });
    }
  }]);

  return BarChart;
}();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = BarChart;
} else if (typeof window !== 'undefined') {
  window.BarChart = BarChart;
}

if (typeof require !== 'undefined') {
  var moment = require('moment');
  var _ = require('lodash');
  var d3 = require('d3');
  var TimelineSignPost = require('./timeline-sign-post.js');
}

// This all needs to move to a require / module style

var TimelineChart = function () {
  function TimelineChart(el, eventData) {
    _classCallCheck(this, TimelineChart);

    this.el = el;
    this.eventData = eventData;
    this._init();
  }

  _createClass(TimelineChart, [{
    key: '_init',
    value: function _init() {
      this._dimensions();
      this._buildCanvas();
      this._buildTimelineAxis();
      this._buildEvents();
      // this._addTooltip();
    }
  }, {
    key: 'update',
    value: function update(eventData) {
      this.eventData = eventData;
      this._addEvents();
    }
  }, {
    key: '_buildCanvas',
    value: function _buildCanvas() {
      this.chart = d3.select(this.el);
    }
  }, {
    key: '_buildEvents',
    value: function _buildEvents() {
      this._buildEventsContainer();
      this._addEvents();
    }
  }, {
    key: '_buildEventsContainer',
    value: function _buildEventsContainer() {
      this.eventsContainer = this.chart.append('g').classed('timeline-events', true).attr('transform', 'translate(0, ' + this.timelinePositionY + ')');
    }
  }, {
    key: '_addEvents',
    value: function _addEvents() {
      var _this2 = this;

      var THIS = this;

      this.eventPoints = this.eventsContainer.selectAll('g').data(this.eventData);

      // Update existing
      this.eventPoints.classed('updated', true).attr('transform', function (d) {
        return _this2._positionEvent(d);
      }).call(function (parent) {
        THIS._updateEventCircles(parent);
      });

      // Enter new elements
      this.eventPoints.enter().append('g').classed('timeline-event', true).attr('transform', function (d) {
        return _this2._positionEvent(d);
      }).call(function (parent) {
        THIS._enterEventCircles(parent);
        THIS._enterEventSignPosts(parent);
        THIS._enterEventLabels(parent);
      });

      // Remove old
      this.eventPoints.exit().remove();
    }
  }, {
    key: '_enterEventCircles',
    value: function _enterEventCircles(parent) {
      parent.append('circle').attr('r', 4);
    }
  }, {
    key: '_updateEventCircles',
    value: function _updateEventCircles(parent) {
      parent.select('circle').text(function (d) {
        return d.signPost;
      });
    }
  }, {
    key: '_enterEventLabels',
    value: function _enterEventLabels(parent) {
      parent.append('text').text(function (d) {
        return d.label;
      }).classed('timeline-label', true);
    }
  }, {
    key: '_enterEventSignPosts',
    value: function _enterEventSignPosts(parent) {
      // parent.call((event) => {
      new TimelineSignPost(parent).render();
      // });
    }
  }, {
    key: '_positionEvent',
    value: function _positionEvent(event) {
      var scale = this._xAxisMonthScale();
      var monthCountSinceStartDate = moment(event.date).diff(this._startDate(), 'months');

      return 'translate(' + scale(monthCountSinceStartDate) + ', 0)';
    }
  }, {
    key: '_addTooltip',
    value: function _addTooltip() {
      this.tip = d3.tip().attr('class', 'chart-tip').offset([-10, 0]).html(function (d) {
        var html = '';
        if (d.tipTitle) html += '<h3>' + d.tipTitle + '</h3>';
        if (d.tipBody) html += '<p>' + d.tipBody + '</p>';
        return html;
      });

      this.chart.call(this.tip);
    }
  }, {
    key: '_buildTimelineAxis',
    value: function _buildTimelineAxis() {
      this._buildXAxisContainer();
      this._buildXAxisPoints();
    }
  }, {
    key: '_buildXAxisContainer',
    value: function _buildXAxisContainer() {
      this.timelineContainer = this.chart.append('g').classed('axis axis--dotted', true).attr('transform', 'translate(0, ' + this.timelinePositionY + ')');
    }
  }, {
    key: '_buildXAxisPoints',
    value: function _buildXAxisPoints() {
      var scale = this._xAxisYearScale();

      this.timelineContainer.selectAll('circle').data(_.range(0, this._countYears())).enter().append('circle').attr('r', 1).attr('transform', function (year) {
        return 'translate(' + scale(year) + ', 0)';
      });
    }
  }, {
    key: '_xAxisYearScale',
    value: function _xAxisYearScale() {
      return d3.scaleLinear().domain([0, this._countYears()]).range([0, this.chartWidth]);
    }
  }, {
    key: '_xAxisMonthScale',
    value: function _xAxisMonthScale() {
      return d3.scaleLinear().domain([0, this._countMonths()]).range([0, this.chartWidth]);
    }
  }, {
    key: '_countMonths',
    value: function _countMonths() {
      return moment(this._endDate()).diff(this._startDate(), 'months');
    }
  }, {
    key: '_countYears',
    value: function _countYears() {
      return moment(this._endDate()).diff(this._startDate(), 'years');
    }
  }, {
    key: '_startDate',
    value: function _startDate() {
      var events = this._sortByDate(this.eventData);
      return events[0].date;
    }
  }, {
    key: '_endDate',
    value: function _endDate() {
      var events = this._sortByDate(this.eventData);
      return events[events.length - 1].date;
    }
  }, {
    key: '_sortByDate',
    value: function _sortByDate(events) {
      var copy = events.slice(0);
      return copy.sort(function (a, b) {
        if (moment(a.date).isBefore(b.date)) return -1;
        if (moment(a.date).isAfter(b.date)) return 1;
      });
    }
  }, {
    key: '_dimensions',
    value: function _dimensions() {
      this.chartWidth = this.el.getBoundingClientRect().width;
      this.chartHeight = this.el.getBoundingClientRect().height;
      this.timelinePositionY = this.chartHeight / 2;
    }
  }]);

  return TimelineChart;
}();

;

if (typeof module !== 'undefined' && module.exports) {
  module.exports = TimelineChart;
} else if (typeof window !== 'undefined') {
  window.TimelineChart = TimelineChart;
}

if (typeof require !== 'undefined') {
  var d3 = require('d3');
}

var SIGNHEIGHT = '20';
var SIGNWIDTH = '40';
var BORDERRADIUS = '2';
var LOWSIGNOFFSET = -(SIGNHEIGHT * 1.5);
var HIGHSIGNOFFSET = -(SIGNHEIGHT * 2.65);

var TimelineEventSignPost = function () {
  function TimelineEventSignPost(parent) {
    _classCallCheck(this, TimelineEventSignPost);

    this.parent = parent;
  }

  _createClass(TimelineEventSignPost, [{
    key: 'render',
    value: function render() {
      this._container();
      this._line();
      this._sign();
    }
  }, {
    key: '_container',
    value: function _container() {
      this.container = this.parent.filter(function (d) {
        return d.signPost ? true : false;
      }).append('g').classed('timeline-sign-post', true).classed('timeline-sign-post--important', function (d) {
        return d.important ? true : false;
      });
    }
  }, {
    key: '_line',
    value: function _line() {
      this.container.append('line').attr('x1', 0).attr('y1', 0).attr('x1', 0).attr('y1', function (event) {
        return event.important ? HIGHSIGNOFFSET : LOWSIGNOFFSET;
      });
    }
  }, {
    key: '_sign',
    value: function _sign() {
      this._signContainer();
      this._signBackground();
      this._signText();
    }
  }, {
    key: '_signContainer',
    value: function _signContainer() {
      this.signContainer = this.container.append('g').classed('timeline-sign', true).attr('transform', 'translate(0,0)').attr('transform', function (event) {
        var offset = event.important ? HIGHSIGNOFFSET : LOWSIGNOFFSET;
        return 'translate(0,' + offset + ')';
      });
    }
  }, {
    key: '_signBackground',
    value: function _signBackground() {
      this.signContainer.append('rect').attr('height', SIGNHEIGHT).attr('y', -(SIGNHEIGHT / 2)).attr('width', SIGNWIDTH).attr('x', -(SIGNWIDTH / 2)).attr('rx', BORDERRADIUS).attr('ry', BORDERRADIUS);
    }
  }, {
    key: '_signText',
    value: function _signText() {
      this.signContainer.append('text').text(function (d) {
        return d.signPost;
      }).attr('text-anchor', 'middle').attr('alignment-baseline', 'middle');
    }
  }]);

  return TimelineEventSignPost;
}();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = TimelineEventSignPost;
} else if (typeof window !== 'undefined') {
  window.TimelineSignPost = TimelineEventSignPost;
}

if (typeof require !== 'undefined') {
  var moment = require('moment');
  var _ = require('lodash');
  var d3 = require('d3');
}

var ValueLineChart = function () {
  function ValueLineChart(el) {
    _classCallCheck(this, ValueLineChart);

    this.el = el;
    this._buildSvg();
    this._buildChartContainer();
    this._setupResize();
    this._setupTips();
  }

  _createClass(ValueLineChart, [{
    key: 'update',
    value: function update(data) {
      this.data = data ? this._prepData(data) : this.data;
      this._combineValuations();
      this._draw();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      // ensure all event listeners are cleaned up
      if (typeof window !== 'undefined') d3.select(window).on('resize', null);
    }
  }, {
    key: '_draw',
    value: function _draw() {
      this._calcDimensions();
      this._shiftChartContainer();
      this._calcScales();
      this._axes();
      this._addPhotoCropper();
      this._segmentConnectors();
      this._segments();
    }
  }, {
    key: '_buildSvg',
    value: function _buildSvg() {
      this.svg = d3.select(this.el);
    }
  }, {
    key: '_buildChartContainer',
    value: function _buildChartContainer() {
      this.chart = this.svg.append('g');
    }
  }, {
    key: '_shiftChartContainer',
    value: function _shiftChartContainer() {
      this.chart.attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');
    }
  }, {
    key: '_axes',
    value: function _axes() {
      this._drawXAxis();
      this._drawYAxis();
    }
  }, {
    key: '_segments',
    value: function _segments() {
      var _this3 = this;

      var line = d3.line().curve(d3.curveCardinal).x(function (d) {
        return _this3.scaleX(d.date);
      }).y(function (d, i) {
        return _this3.scaleY(d.valuation);
      });

      this.segment = this.chart.selectAll('.segment').data(this.data.segments).enter().append('g').attr('class', 'segment');

      this.segment.filter(function (d) {
        return d.valuations.length > 1;
      }).append('path').attr('class', 'line').attr('d', function (d) {
        return line(d.valuations);
      });

      this.segment.selectAll('g').data(function (d) {
        return d.valuations;
      }).enter().append('g').classed('datapoint', true).call(function (parentDatapoint) {
        _this3._addDataPoints(parentDatapoint);
      });
    }
  }, {
    key: '_segmentConnectors',
    value: function _segmentConnectors() {
      var _this4 = this;

      var line = d3.line().x(function (d) {
        return _this4.scaleX(d.date);
      }).y(function (d, i) {
        return _this4.scaleY(d.valuation);
      });

      this.connector = this.chart.selectAll('.line--connector').data(this.data.connectors.filter(function (d) {
        return d.valuations.every(Boolean);
      })).enter().append('path').attr('class', 'line line--connector').attr('d', function (d) {
        return line(d.valuations);
      });
    }
  }, {
    key: '_addDataPoints',
    value: function _addDataPoints(datapoint) {
      this._photoPosts(datapoint);
      this._pointBorders(datapoint);
      this._points(datapoint);
      this._photoBorders(datapoint);
      this._photos(datapoint);
    }
  }, {
    key: '_photoPosts',
    value: function _photoPosts(datapoint) {
      var _this5 = this;

      datapoint.filter(function (d, i) {
        return i === 0 && d.source && d.source.photoUrl;
      }).append('line').classed('photo-post', true).attr('x1', function (d) {
        return _this5.scaleX(d.date);
      }).attr('y1', function (d) {
        return _this5.scaleY(d.valuation);
      }).attr('x2', function (d) {
        return _this5.scaleX(d.date);
      }).attr('y2', function (d) {
        return _this5.scaleY(d.valuation) + _this5._getPhotoOffset(d.valuation);
      });
    }
  }, {
    key: '_points',
    value: function _points(datapoint) {
      var _this6 = this;

      datapoint.append('circle').classed('point', true).attr('cx', function (d) {
        return _this6.scaleX(d.date);
      }).attr('cy', function (d) {
        return _this6.scaleY(d.valuation);
      }).attr('r', 3.5).on('mouseover', this.tip.show).on('mouseout', this.tip.hide);
    }
  }, {
    key: '_pointBorders',
    value: function _pointBorders(datapoint) {
      var _this7 = this;

      datapoint.filter(function (d, i, nodes) {
        return i === 0 || i === nodes.length - 1;
      }).append('circle').classed('point-border', true).attr('cx', function (d) {
        return _this7.scaleX(d.date);
      }).attr('cy', function (d) {
        return _this7.scaleY(d.valuation);
      }).attr('r', 7.5);
    }
  }, {
    key: '_photoBorders',
    value: function _photoBorders(datapoint) {
      var _this8 = this;

      datapoint.filter(function (d, i) {
        return i === 0 && d.source && d.source.photoUrl;
      }).append('circle').classed('photo-border', true).attr('r', this._getResponsivePhotoWidth() / 2).attr('transform', function (d) {
        var x = _this8.scaleX(d.date);
        var y = _this8.scaleY(d.valuation) + _this8._getPhotoOffset(d.valuation, 'middle');
        return 'translate(' + x + ',' + y + ')';
      });
    }
  }, {
    key: '_photos',
    value: function _photos(datapoint) {
      var _this9 = this;

      var urlBase = typeof document !== 'undefined' ? document.location.href : '';

      datapoint.filter(function (d, i, a) {
        return i === 0 && d.source && d.source.photoUrl;
      }).append('image').classed('photo', true).attr('xlink:href', function (d) {
        return d.source.photoUrl;
      }).attr('width', this._getResponsivePhotoWidth()).attr('height', this._getResponsivePhotoWidth()).attr('transform', function (d) {
        var x = _this9.scaleX(d.date) - _this9._getResponsivePhotoWidth() / 2;
        var y = _this9.scaleY(d.valuation) + _this9._getPhotoOffset(d.valuation, 'top');
        return 'translate(' + x + ',' + y + ')';
      }).attr('preserveAspectRatio', 'xMaxYMin slice').style('clip-path', 'url(' + urlBase + '#photoCircleCrop)'); // http://stackoverflow.com/a/18265336/580366
    }
  }, {
    key: '_drawXAxis',
    value: function _drawXAxis() {
      var years = moment(this.xDomain[1]).diff(this.xDomain[0], 'years');
      var valuationCount = this.allValuations.length;

      var xAxis = d3.axisBottom(this.scaleX).tickFormat(d3.timeFormat(years > 0 ? '%b \'%y' : '%b'));

      if (years > 0) {
        // Reduced room with larger labels specified above.
        xAxis.ticks(6);
      } else {
        xAxis.ticks(valuationCount);
      }

      this.chart.append('g').attr('class', 'axis axis--x').attr('transform', 'translate(0,' + this.chartHeight + ')').call(xAxis);
    }
  }, {
    key: '_drawYAxis',
    value: function _drawYAxis() {
      var formatter = d3.format('.2s');

      var yAxis = d3.axisRight(this.scaleY).tickSize(this.outerWidth).tickArguments([3]).tickFormat(d3.format('.2s'));

      // Add to outer svg because it's outside the graph on the left
      // Prepend instead of append so that it's under the chart
      this.yAxis = this.svg.insert('g', ':first-child').attr('class', 'axis axis--y').attr('transform', 'translate(0, ' + this.margin.top + ')').call(yAxis);

      this.yAxis.selectAll('text').attr('x', 0).attr('dy', -6);
    }
  }, {
    key: '_addPhotoCropper',
    value: function _addPhotoCropper() {
      var halfPhotoWidth = this._getResponsivePhotoWidth() / 2;
      this.svg.append('defs').append('clipPath').attr('id', 'photoCircleCrop').append('circle').attr('r', halfPhotoWidth).attr('cx', halfPhotoWidth).attr('cy', halfPhotoWidth);
    }
  }, {
    key: '_setupTips',
    value: function _setupTips() {
      // Lame hack for tests to run. We'll need to dev our own tooltip at some point.
      if (!d3.tip) {
        this.tip = { show: function show() {}, hide: function hide() {} };
        return;
      }

      this.tip = d3.tip().attr('class', 'chart-tip').offset([-18, 0]).html(function (d) {
        return moment(d.date).format('MMM YYYY') + '<em>$' + d.valuation.toLocaleString() + '</em>';
      });

      this.chart.call(this.tip);
    }
  }, {
    key: '_calcDimensions',
    value: function _calcDimensions() {
      this.margin = { top: 20, right: 20, bottom: 30, left: 60 };
      this.outerWidth = this.el.getBoundingClientRect().width;
      this.outerHeight = this.el.getBoundingClientRect().height;
      this.chartWidth = this.outerWidth - this.margin.left - this.margin.right;
      this.chartHeight = this.outerHeight - this.margin.top - this.margin.bottom;
    }
  }, {
    key: '_calcScales',
    value: function _calcScales() {
      this.scaleX = d3.scaleTime().domain(this.xDomain).range([0, this.chartWidth]);
      this.scaleY = d3.scaleLinear().domain(this._getPaddedYDomain()).range([this.chartHeight, 0]);
    }
  }, {
    key: '_combineValuations',
    value: function _combineValuations() {
      var data = _.cloneDeep(this.data);
      var valuations = [];
      data.segments.forEach(function (segment) {
        return valuations = valuations.concat(segment.valuations);
      });
      this.allValuations = valuations;
    }
  }, {
    key: '_prepData',
    value: function _prepData(data) {
      var transformedData = _.cloneDeep(data);
      transformedData = this._setupSourceAndDates(transformedData);
      transformedData.connectors = this._connectorData(transformedData);

      return transformedData;
    }
  }, {
    key: '_setupSourceAndDates',
    value: function _setupSourceAndDates(data) {
      var _this10 = this;

      var transformedData = _.cloneDeep(data);
      var parseTime = d3.timeParse('%Y-%m');

      transformedData.segments.map(function (segment, i) {
        segment.valuations = segment.valuations.map(function (valuation) {
          valuation.source = segment.source;
          valuation.date = parseTime(_this10._setDateToFirstOfMonth(valuation.date));
          return valuation;
        });
      });

      return transformedData;
    }
  }, {
    key: '_connectorData',
    value: function _connectorData(data) {
      var connectors = [];

      data.segments.forEach(function (segment, i) {
        if (i > 0) {
          var connector = {};
          var previousSegment = data.segments[i - 1];
          connector.valuations = [previousSegment.valuations[previousSegment.valuations.length - 1], segment.valuations[0]];
          connectors.push(connector);
        }
      });

      return connectors;
    }
  }, {
    key: '_setDateToFirstOfMonth',
    value: function _setDateToFirstOfMonth(date) {
      return moment(date).format('YYYY-MM');
    }
  }, {
    key: '_getPaddedYDomain',
    value: function _getPaddedYDomain() {
      var min = d3.min(this.allValuations, function (d) {
        return d.valuation;
      });
      var max = d3.max(this.allValuations, function (d) {
        return d.valuation;
      });

      // give the chart some breathing room, make it less dramatic
      min -= min * .1;
      max += max * .05;

      return [min, max];
    }
  }, {
    key: '_getPhotoOffset',
    value: function _getPhotoOffset(value, origin) {
      var PHOTO_WIDTH = this._getResponsivePhotoWidth();
      var offset = PHOTO_WIDTH * 1.333;

      if (origin === 'middle') offset += PHOTO_WIDTH / 2;

      if (this.scaleY(value) > this.chartHeight / 2) {
        if (origin === 'top') offset += PHOTO_WIDTH;

        return -offset;
      }

      return offset;
    }
  }, {
    key: '_getResponsivePhotoWidth',
    value: function _getResponsivePhotoWidth() {
      if (this._isSmallSize()) return 20;

      return 26;
    }
  }, {
    key: '_isSmallSize',
    value: function _isSmallSize() {
      return this.outerWidth < 450;
    }
  }, {
    key: '_setupResize',
    value: function _setupResize() {
      var _this11 = this;

      if (this._redrawChart) return;

      this._redrawChart = _.debounce(function () {
        _this11.chart.selectAll('*').remove();
        _this11.yAxis.remove();
        _this11._draw();
      }, 250, { leading: false });

      if (typeof window !== 'undefined') d3.select(window).on('resize', this._redrawChart);
    }
  }, {
    key: 'xDomain',
    get: function get() {
      return d3.extent(this.allValuations, function (d) {
        return d.date;
      });
    }
  }]);

  return ValueLineChart;
}();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = ValueLineChart;
} else if (typeof window !== 'undefined') {
  window.ValueLineChart = ValueLineChart;
}

angular.module('homebot.directives').directive('agentChartPhoto', ['$timeout', function ($timeout) {
  return {
    restrict: 'E',
    controllerAs: 'agentChartPhotoCtrl',
    bindToController: {},
    scope: {},
    templateUrl: '/homes/templates/partials/agent-chart-photo.html',
    controller: function controller() {},
    link: function link(scope, el, attrs, ctrl) {
      console.log(el);
    }
  };
}]);

angular.module('homebot.directives').directive('anchor', ['$timeout', 'ScrollService', '$location', function ($timeout, ScrollService, $location) {
  return {
    restrict: 'E',
    controllerAs: 'anchorCtrl',
    bindToController: {
      onFocus: '&',
      hash: '@'
    },
    scope: {},
    controller: function controller() {},
    link: function link(scope, el, attrs, ctrl) {

      ctrl.runOnLoad = function () {
        var target = void 0;

        if ($location.hash()) target = $location.hash();else if ($location.search().section) target = $location.search().section;

        $timeout(function () {
          ctrl.scrollPage(target);
        }, 1200);
      };

      ctrl.runOnHashChange = function () {
        ScrollService.subscribe(scope, function (e, data) {
          ctrl.scrollPage(data.target);
        });
      };

      ctrl.scrollPage = function (target) {
        if (target !== ctrl.hash) return;

        var scrollAdjustment = window.outerHeight / 20;
        var scrollTop = el[0].getBoundingClientRect().top - scrollAdjustment;

        $('html, body').animate({ scrollTop: document.body.scrollTop + scrollTop }, function () {
          if (ctrl.onFocus) ctrl.onFocus();

          scope.$apply();
        });
      };

      ctrl.runOnLoad();
      ctrl.runOnHashChange();
    }
  };
}]);

angular.module('homebot.directives').directive('autosize', function () {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs, undefined) {
      _.defer(function () {
        autosize(el[0]);
      });
    }
  };
});

angular.module('homebot.directives').directive('backLink', [function () {
  return {
    restrict: 'A',
    controllerAs: 'backLinkCtrl',
    bindToController: {
      fallbackUrl: '@'
    },
    scope: {},
    controller: function controller() {},

    link: function link($scope, el, attrs) {
      el.bind('click', function () {
        var origin = window.location.protocol + '//' + window.location.host + '/admin';

        if (document.referrer.indexOf(origin) === 0) // assume back page is correct if they came from our domain
          window.history.back();else el[0].setAttribute('href', attrs.fallbackUrl);
      });
    }
  };
}]);

angular.module('homebot.directives').directive('buyingPowerSection', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'AE',
    controllerAs: 'buyingPowerCtrl',
    bindToController: {
      agent: '=',
      home: '=',
      userId: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/section-buying-power.html',
    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.lookup = function (prop) {
        return dictionary[prop](ctrl.home);
      };
    },

    link: function link($scope, el, attrs, ctrl) {}
  };
}]);

angular.module('homebot.directives').directive('cashoutSection', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'cashoutCtrl',
    bindToController: {
      agent: '=',
      loans: '=',
      home: '=',
      userId: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/section-cashout.html',

    controller: function controller() {
      var INITIAL_LTV = 80;
      var MINIMUM_LTV_TO_SUGGEST_CASHOUT = 80;
      var MINIMUM_LTV_TO_DISPLAY_SLIDER = 77;
      var modifiedHome = {};
      var loans;
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = home || modifiedHome;
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        modifiedHome = _.cloneDeep(ctrl.home);
        loans = _.isArray(ctrl.loans) ? ctrl.loans : [ctrl.loans];
        modifiedHome.loans = loans;
      };

      ctrl.toggle = function (prop) {
        ctrl[prop] = !ctrl[prop];
      };

      ctrl.ltv = INITIAL_LTV;
      ctrl.minimumLtvToSuggestCashout = MINIMUM_LTV_TO_SUGGEST_CASHOUT;
      ctrl.minimumLtvToDisplaySlider = MINIMUM_LTV_TO_DISPLAY_SLIDER;
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('cashoutCtrl.loans', ctrl.update);
    }
  };
}]);

angular.module('homebot.directives').directive('cmaQuestions', ['DataService', 'UtilService', 'Dictionary', function (DataService, utils, Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'questionsCtrl',
    bindToController: {
      home: '=',
      userId: '@',
      onComplete: '&',
      hasRecentlyRequested: '&'
    },
    scope: {},
    templateUrl: '/homes/templates/partials/cma-questions.html',

    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.step = ctrl.hasRecentlyRequested() ? 1 : 0;
      ctrl.skipped = false;
      ctrl.agent = ctrl.home.agent[0];
      ctrl.answers = ctrl.home.answers;
      ctrl.homeFacts = {
        bedrooms: ctrl.home.bedrooms,
        bathrooms: ctrl.home.bathrooms,
        finishedSqFt: ctrl.home.finishedSqFt
      };

      if (ctrl.agent.type !== 'realestate' && dictionary.sellingAgent(ctrl.home)) ctrl.previousRea = dictionary.sellingAgent(ctrl.home);

      ctrl.nextQuestion = function (step) {
        ctrl.step = step || Math.floor(ctrl.step + 1);
      };

      ctrl.finishQuestions = function () {
        ctrl.onComplete({
          requestedCma: !ctrl.skipped
        });
        utils.track('CMARequestFinished');
      };

      ctrl.requestCma = function (cmaBuyersAgentPreferred) {
        // TODO: This will be combined into one call on the api
        DataService.saveCMARequest(ctrl.home.id, cmaBuyersAgentPreferred).then(function () {
          return DataService.trackHome({
            source: 'user',
            event: 'cma-request',
            homeId: ctrl.home.id,
            userId: ctrl.userId,
            agentId: ctrl.agent.id,
            isEstimateCorrect: ctrl.answers.isEstimateCorrect
          });
        }).then(function () {
          ctrl.home.hasRequestedCMA = moment().toDate();
        }).catch(function (e) {
          utils.trackException('Save CMA Request', e);
          console.error(e);
        });

        utils.track('CMARequest');
        ctrl.nextQuestion();
      };

      ctrl.skipCmaRequest = function () {
        utils.track('CMARequestSkipped');
        ctrl.skipped = true;
        ctrl.nextQuestion();
      };

      ctrl.setAnswer = function (question, answer) {
        answer = answer.constructor === 'string' ? answer.trim() : answer;

        utils.track('CMAQuestionAnswered', question);

        ctrl.answers[question] = answer;

        DataService.saveAnswer(question, answer, ctrl.home.id).catch(function (err) {
          utils.trackException('Save Answer', err);
        });
      };

      ctrl.saveHomeUpdatedDescription = function () {
        var answer = ctrl.answers.homeUpdatedDescription ? ctrl.answers.homeUpdatedDescription.trim() : null;

        if (answer) ctrl.setAnswer('homeUpdatedDescription', answer);
      };
    }
  };
}]);

angular.module('homebot.directives').directive('cmaRequest', [function () {
  return {
    restrict: 'A',
    controllerAs: 'cmaRequestCtrl',
    bindToController: {
      agent: '=',
      previousRea: '=',
      requestCma: '&onRequestCma',
      skipCmaRequest: '&onSkipCmaRequest',
      nextQuestion: '&onNextQuestion'
    },
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      return attrs.templateUrl;
    },
    controller: function controller() {}
  };
}]);

var ANSWER_KEYS = ['homeFactsCorrect', 'homeUpdated', 'isEstimateCorrect'];

angular.module('homebot.directives').directive('cmaSection', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'cmaSectionCtrl',
    bindToController: {
      home: '=',
      userId: '@',
      onClose: '&'
    },
    scope: {},
    templateUrl: '/homes/templates/partials/cma-section.html',

    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.lookup = function (prop, args) {
        return dictionary[prop](ctrl.home, args);
      };

      ctrl.hasRecentlyRequested = function () {
        var hasRequestedCMA = ctrl.home.hasRequestedCMA;
        var oneYearAgo = moment().subtract(1, 'year');
        return hasRequestedCMA && moment(hasRequestedCMA).isAfter(oneYearAgo);
      };

      ctrl.hasCompletedCMAQuestions = function () {
        return ANSWER_KEYS.every(function (key) {
          return ctrl.home.answers[key];
        });
      };

      ctrl.hasCompletedAndRequested = function () {
        return ctrl.hasRecentlyRequested() && ctrl.hasCompletedCMAQuestions();
      };

      ctrl.agent = ctrl.home.agent[0];
      ctrl.cmaSourceAgent = ctrl.lookup('cmaSourceAgent');
      ctrl.cmaProgress = ctrl.hasCompletedAndRequested() ? 'requested' : 'incomplete';

      ctrl.onCmaQuestionsComplete = function (requestedCma) {
        if (requestedCma) ctrl.cmaProgress = 'requested';else ctrl.cmaProgress = 'skipped-request';
      };
    }
  };
}]);

angular.module('homebot.directives').directive('collapse', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'collapse',
    bindToController: {},
    scope: {},

    controller: function controller() {},

    link: function link($scope, el, attrs, ctrl) {
      // $attrs.$observe('collapse', ctrl.update);
    }
  };
}]);

angular.module('homebot.directives').directive('companyBranding', [function () {
  return {
    restrict: 'E',
    controllerAs: 'companyBrandingCtrl',
    bindToController: {
      office: '='
    },
    scope: {},
    templateUrl: '/homes/templates/partials/company-branding.html',

    controller: function controller() {
      var ctrl = this;
    }
  };
}]);

angular.module('homebot.directives').directive('directMessage', ['DataService', 'PageNotificationService', 'RollbarService', function (DataService, PageNotificationService, RollbarService) {
  return {
    restrict: 'E',
    controllerAs: 'directMessageCtrl',
    bindToController: {
      coRecipientId: '@',
      homeId: '@',
      originalMessage: '@',
      recipientId: '@',
      topic: '@',
      userId: '@'
    },
    replace: true,
    templateUrl: '/homes/templates/partials/direct-message.html',
    scope: {},
    controller: function controller() {
      var ctrl = this;
      ctrl.message = ctrl.originalMessage || '';

      ctrl.submit = function () {
        var message = _.trim(ctrl.message);

        if (!message) return;

        ctrl.loading = true;

        if (ctrl.recipientId && ctrl.coRecipientId) sendSponsorMessage(message);else sendMessage(message);
      };

      function sendMessage(message) {
        var agentId = ctrl.recipientId || ctrl.coRecipientId;

        DataService.sendMessage(ctrl.homeId, ctrl.userId, agentId, message, ctrl.topic).then(onSuccess).catch(onError);
      }

      function sendSponsorMessage(message) {
        var args = {
          coRecipientId: ctrl.coRecipientId,
          message: message,
          recipientId: ctrl.recipientId,
          topic: ctrl.topic,
          userId: ctrl.userId
        };

        DataService.sendSponsorMessage(ctrl.homeId, args).then(onSuccess).catch(onError);
      }

      function onSuccess() {
        PageNotificationService.success('Message sent!');
        ctrl.loading = false;
        ctrl.message = ctrl.originalMessage || '';
      }

      function onError(e) {
        ctrl.loading = false;
        PageNotificationService.error('There was an error sending your message.');
        RollbarService.error('Send Message Error', e);
      }
    },

    link: function link($scope, el, attrs) {}
  };
}]);

angular.module('homebot.directives').directive('explainNetWorth', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'netExplainCtrl',
    bindToController: {
      loans: '=',
      home: '='
    },
    scope: {},
    templateUrl: '/homes/templates/explain-net-worth.html',

    controller: function controller() {
      var modifiedHome = {};
      var loans;
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = home || modifiedHome;
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        modifiedHome = _.cloneDeep(ctrl.home);
        loans = _.isArray(ctrl.loans) ? ctrl.loans : [ctrl.loans];
        modifiedHome.loans = loans;
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('netExplainCtrl.loans', ctrl.update);
    }
  };
}]);

if (typeof require !== 'undefined' && typeof _ === 'undefined') {
  var _ = require('lodash');
}

angular.module('homebot.directives').directive('hasFeature', ['ngIfDirective', 'AccountService', function (ngIfDirective, AccountService) {
  // Expanding on ngIf directive gives
  // hasFeature all the benefits of ngIf
  // http://stackoverflow.com/a/29010910/580366

  var ngIf = ngIfDirective[0];

  return {
    transclude: ngIf.transclude,
    priority: ngIf.priority - 1,
    terminal: ngIf.terminal,
    restrict: ngIf.restrict,

    link: function link(scope, el, attrs) {
      var ifEvaluator;
      var initialNgIf = attrs.ngIf;
      var features = attrs.hasFeature.split(',');

      function hasFeature(features) {
        return _.every(features, AccountService.hasFeature);
      };

      if (initialNgIf) {
        ifEvaluator = function ifEvaluator() {
          return scope.$eval(initialNgIf) && hasFeature(features);
        };
      } else {
        ifEvaluator = function ifEvaluator() {
          return hasFeature(features);
        };
      }

      attrs.ngIf = ifEvaluator;
      ngIf.link.apply(ngIf, arguments);
    }
  };
}]);

angular.module('homebot.directives').directive('homeInviteForm', ['DataService', 'HelperService', 'UtilService', 'PageNotificationService', function (DataService, helpers, utils, PageNotificationService) {
  return {
    controllerAs: 'ctrl',
    bindToController: {
      userId: '@',
      agentId: '@'
    },
    restrict: 'E',
    scope: {},
    templateUrl: '/homes/templates/ho-invite.html',
    controller: function controller() {
      var ctrl = this;

      var onSave = function onSave(invite) {
        PageNotificationService.success('An invitation has been sent to ' + ctrl.invite.firstName + ' ' + ctrl.invite.lastName + '.');
        ctrl.loading = false;
        ctrl.invite = {};
      };

      var onError = function onError(errorMsg) {
        ctrl.error = errorMsg;
        ctrl.loading = false;
      };

      ctrl.addInvite = function () {
        var invite = {
          firstName: ctrl.invite.firstName,
          lastName: ctrl.invite.lastName,
          email: ctrl.invite.email,
          inviterId: ctrl.userId,
          agentId: ctrl.agentId
        };

        ctrl.loading = true;

        DataService.addInvite(invite).then(onSave).catch(onError);

        utils.track('InviteAnotherHomeowner');
      };
    }
  };
}]);

angular.module('homebot.directives').directive('homeValueChart', ['DataService', function (DataService) {
  return {
    restrict: 'E',
    controllerAs: 'homeValueChartCtrl',
    bindToController: {
      homeId: '@',
      history: '='
    },
    scope: {},
    templateUrl: '/homes/templates/partials/home-value-chart.html',
    controller: function controller() {
      var ctrl = this;

      ctrl.setupGraph = function () {
        if (!ctrl.history) return;
        ctrl.chart = new ValueLineChart(ctrl.el).update(ctrl.history);
      };
    },
    link: function link($scope, el, attrs, ctrl) {
      ctrl.el = el.find('svg')[0];

      el.on('$destroy', function () {
        if (ctrl.chart) ctrl.chart.destroy();
      });

      $scope.$watch('homeValueChartCtrl.history', function (oldVal, newVal) {
        if (oldVal !== newVal) ctrl.setupGraph();
      });

      ctrl.setupGraph();
    }
  };
}]);

angular.module('homebot.directives').directive('interestKillsSection', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'interestCtrl',
    bindToController: {
      loans: '='
    },
    scope: {},
    templateUrl: '/homes/templates/section-interest-kills.html',

    controller: function controller() {
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = { loans: ctrl.loans };
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        ctrl.interestStatus = ctrl.lookup('interestStatus');
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('interestCtrl.loans', ctrl.update);
    }
  };
}]);

angular.module('homebot.directives').directive('learnMoreMortgage', ['$rootScope', function ($rootScope) {
  return {
    restrict: 'A',
    controllerAs: 'learnCtrl',
    bindToController: {
      loans: '=',
      agent: '=',
      phoneTrack: '@',
      emailTrack: '@'
    },
    scope: {},
    transclude: true,
    templateUrl: '/homes/templates/partials/learn-more-mortgage.html',
    controller: function controller() {
      var ctrl = this;

      ctrl.openDisclaimerModal = function () {
        $rootScope.$broadcast('openDisclaimerModal', true);
      };
    }
  };
}]);

angular.module('homebot.directives').directive('modal', ['HelperService', '$rootScope', '$state', function (helpers, $rootScope, $state) {
  return {
    restrict: 'C',
    link: function link($scope, el, attrs) {
      var isInitialLoad = true;
      var bodyEl = window.document.body;
      var backdrop = $('<div class="modal-backdrop"></div>');
      el.after(backdrop);

      function open() {
        el.addClass('visible');
        backdrop.addClass('visible');
        _.defer(function () {
          bodyEl.classList.add('modal-open');
        }); // defer to animate smoothly
      }

      function close() {
        bodyEl.classList.remove('modal-open');

        _.delay(function () {
          el.removeClass('visible');
          backdrop.removeClass('visible');
        }, 350);
      }

      attrs.$observe('modalToggle', function (newVal) {
        if (!helpers.isFalsey(newVal)) open();else close();
      });

      function closeOnStateChange(event, toState) {
        if (attrs.state !== toState.name) close(false);
      };

      var cleanup = $rootScope.$on('$stateChangeStart', closeOnStateChange);

      $scope.$on('$destroy', cleanup); // removes from $rootScope
    }
  };
}]);

angular.module('homebot.directives').directive('mortgageFooterSimple', ['$rootScope', function ($rootScope) {
  return {
    restrict: 'A',
    controllerAs: 'mortgageFooterCtrl',
    bindToController: {
      agent: '='
    },
    scope: {},
    transclude: true,
    templateUrl: '/homes/templates/partials/mortgage-footer-simple.html',
    controller: function controller() {
      var ctrl = this;

      ctrl.photo = _.get(this, 'agent.sponsor.photo', this.agent.photo);
    }
  };
}]);

angular.module('homebot.directives').directive('mortgageForm', ['DataService', 'HelperService', 'UtilService', 'LoanFormParser', function (DataService, helpers, utils, loanFormParser) {
  return {
    controllerAs: 'ctrl',
    bindToController: {
      addMortgage: '@',
      editMortgage: '=',
      homeId: '@',
      onMortgageSaved: '&',
      onCancel: '&'
    },
    restrict: 'E',
    scope: {},
    templateUrl: '/homes/templates/add-edit-mortgage.html',
    controller: function controller() {
      var ctrl = this;
      ctrl.formStep = 1;

      var onSave = function onSave(loan) {
        ctrl.loading = false;

        if (ctrl.onMortgageSaved) ctrl.onMortgageSaved();
      };

      var onError = function onError(errorMsg) {
        ctrl.error = errorMsg;
        ctrl.loading = false;
        utils.trackException('Add Save Mortgage', errorMsg);
      };

      ctrl.isEditMode = function () {
        return !helpers.isFalsey(ctrl.editMortgage);
      };

      ctrl.setupLoan = function () {
        ctrl.formStep = 1;
        ctrl.deletingLoan = false;

        if (ctrl.isEditMode()) ctrl.mortgage = loanFormParser.parseForEditing(ctrl.editMortgage);else ctrl.mortgage = getNewLoanDefaults();
      };

      ctrl.saveLoan = function () {
        if (!ctrl.homeId) return onError('Home ID is required');

        var loan = loanFormParser.parse(ctrl.mortgage);
        ctrl.loading = true;

        DataService.saveLoan(loan, ctrl.mortgage.id).then(onSave).catch(onError);

        utils.track('SaveMortgage');
      };

      ctrl.addLoan = function () {
        var loan = loanFormParser.parse(ctrl.mortgage);

        DataService.addLoan(loan, ctrl.homeId).then(onSave).catch(onError);

        utils.track('AddMortgage');
      };

      ctrl.submitLoan = function () {
        if (ctrl.isEditMode()) ctrl.saveLoan();else ctrl.addLoan();
      };

      ctrl.deleteLoan = function () {
        ctrl.loading = true;

        DataService.saveLoan({ status: 'deleted' }, ctrl.mortgage.id).then(onSave).catch(onError);

        utils.track('DeleteMortgage');
      };

      ctrl.nextForm = function () {
        ctrl.formStep++;
      };

      ctrl.previousForm = function () {
        ctrl.formStep--;
      };

      function getNewLoanDefaults() {
        return { loan_type: 'FIRST CEL', term: 'FIX30YR' };
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchGroup(['ctrl.editMortgage', 'ctrl.addMortgage'], function (newValues, oldValues) {
        ctrl.setupLoan();
      });
    }
  };
}]);

angular.module('homebot.directives').directive('navDropdownToggle', ['NavDropdownService', function (NavDropdownService) {
  return {
    restrict: 'A',
    controllerAs: 'navDropdownToggleCtrl',
    bindToController: {},
    scope: {},

    controller: function controller() {},

    link: function link($scope, el, attrs, ctrl) {
      $(el).on('click', function () {
        NavDropdownService.set(attrs.navDropdownToggle);

        if (attrs.class === "navigation-dropdown-trigger") {
          $('.navigation-tools').toggleClass('navigation-tools--active');
        }
      });
    }
  };
}]);

angular.module('homebot.directives').directive('navDropdown', ['$rootScope', function ($rootScope) {
  return {
    restrict: 'A',
    controllerAs: 'navDropdownCtrl',
    bindToController: {
      navDropdown: '@'
    },
    scope: {},

    controller: function controller() {
      var ctrl = this;

      $rootScope.$on('NavDropdownChange', function (event, data) {
        if (ctrl.navDropdown === data.currentDropdown) ctrl.dropdownVisible = true;else ctrl.dropdownVisible = false;
      });
    },

    link: function link($scope, el, attrs, ctrl) {
      var $el = $(el);
      var isOpen = false;

      function setupDropdownClose() {
        _.defer(function () {
          $(window).one('click.dropdown', function () {
            $('body').removeClass('spotlight-open');
            $el.fadeOut(200).removeClass('nav-dropdown--open');
            isOpen = false;
          });
        });
      }

      var eventCleanup = $rootScope.$on('NavDropdownChange', function (event, data) {
        if (ctrl.navDropdown === data.currentDropdown && !isOpen) {
          $('body').addClass('spotlight-open');
          $el.fadeIn(200).addClass('nav-dropdown--open');
          setupDropdownClose();
          isOpen = true;
        }
      });

      $scope.$on('$destroy', eventCleanup); // removes from $rootScope
    }
  };
}]);

angular.module('homebot.directives').directive('negativeUnder', [function () {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      attrs.$observe('value', function (newVal) {
        var negativeUnder = attrs.negativeUnder || 0;
        negativeUnder = parseInt(negativeUnder);
        newVal = parseInt(newVal);

        if (newVal < negativeUnder) el.addClass('text-danger').removeClass('text-positive');else el.removeClass('text-danger');
      });
    }
  };
}]);

angular.module('homebot.directives').directive('netWorthSection', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'netWorthCtrl',
    bindToController: {
      loans: '=',
      home: '='
    },
    scope: {},
    templateUrl: '/homes/templates/section-net-worth.html',

    controller: function controller() {
      var modifiedHome = {};
      var loans;
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = home || modifiedHome;
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        modifiedHome = _.cloneDeep(ctrl.home);
        loans = _.isArray(ctrl.loans) ? ctrl.loans : [ctrl.loans];
        modifiedHome.loans = loans;
      };

      ctrl.showTip = function () {
        ctrl.tipOpen = true;
      };

      ctrl.toggleTip = function () {
        ctrl.tipOpen = !ctrl.tipOpen;
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('netWorthCtrl.loans', ctrl.update);
    }
  };
}]);

angular.module('homebot.directives').directive('nightlyRentalSingle', ['Dictionary', 'UtilService', function (Dictionary, utils) {
  return {
    restrict: 'A',
    controllerAs: 'nightlySingleCtrl',
    bindToController: {
      learnMoreAction: '&',
      loans: '=',
      payment: '@',
      rentalNights: '@',
      potential: '=',
      title: '@'
    },
    scope: {},

    templateUrl: function templateUrl(el, attrs) {
      if (attrs.nightlyDataType === 'airdna') return '/homes/templates/partials/nightly-rental.html';

      return '/homes/templates/partials/nightly-rental-static-single.html';
    },

    controller: function controller() {
      var loans;
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.currentChart = 'monthlyRevenue';
      ctrl.monthlyEarnings = 1;

      if (ctrl.potential) {
        ctrl.rentalNightsMax = ctrl.potential.occupancy.ltm * 30;
        ctrl.paymentMax = ctrl.potential.adr.ltm;
        ctrl.rentalNights = ctrl.rentalNightsMax * .4;
        ctrl.payment = ctrl.paymentMax * .7;
      }

      function getCorrectLoan() {
        return [dictionary.highestRateLoan({ loans: ctrl.loans })];
      };

      ctrl.lookup = function (prop, args, home) {
        if (!loans || !loans.length) return '';

        home = home || { loans: loans };
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        loans = getCorrectLoan();
      };

      ctrl.occupancyPercentage = function () {
        return ctrl.rentalNights / ctrl.rentalNightsMax;
      };

      ctrl.nightlyRatePercentage = function () {
        return ctrl.payment / ctrl.paymentMax;
      };

      ctrl.monthlyRevenuePercentage = function () {
        return 1 * ctrl.occupancyPercentage() * ctrl.nightlyRatePercentage();
      };

      ctrl.calculatePercentage = function () {
        if (ctrl.currentChart === 'monthlyRevenue') return ctrl.monthlyRevenuePercentage();
        if (ctrl.currentChart === 'nightlyRate') return ctrl.nightlyRatePercentage();
        if (ctrl.currentChart === 'monthlyOccupancy') return ctrl.occupancyPercentage();
      };

      ctrl.updateEarnings = function () {
        if (ctrl.potential) {
          ctrl.monthlyEarnings = ctrl.potential.revenue.ltm * ctrl.monthlyRevenuePercentage() / 12;
          ctrl.annualEarnings = ctrl.potential.revenue.ltm * ctrl.monthlyRevenuePercentage();
        } else {
          ctrl.monthlyEarnings = ctrl.payment * ctrl.rentalNights;
        }
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('nightlySingleCtrl.loans', ctrl.update);
      $scope.$watch('nightlySingleCtrl.payment', ctrl.updateEarnings);
      $scope.$watch('nightlySingleCtrl.rentalNights', ctrl.updateEarnings);
    }
  };
}]);

angular.module('homebot.directives').directive('nightlyRentalsSection', ['APP_CONFIG', 'DataService', 'RollbarService', 'UtilService', '$window', function (APP_CONFIG, DataService, RollbarService, utils, $window) {
  return {
    restrict: 'A',
    controllerAs: 'nightlyCtrl',
    bindToController: {
      agent: '=',
      loans: '=',
      home: '=',
      userId: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/section-nightly-rentals.html',

    controller: function controller() {
      var ctrl = this;

      if (APP_CONFIG.FEATURE_AIRDNA !== 1) {
        ctrl.viewState = 'staticFallback';
        return;
      }

      var args = {
        address: ctrl.home.address.street,
        bedrooms: ctrl.home.bedrooms,
        bathrooms: ctrl.home.bathrooms,
        accommodates: ctrl.home.bedrooms * 1 || 2,
        zipcode: ctrl.home.address.zip
      };

      function showLoading() {
        ctrl.viewState = 'loading';
      }

      function useStaticFallback() {
        ctrl.viewState = 'staticFallback';
      }

      showLoading();

      ctrl.loadAirDna = function (callback) {
        return DataService.getRentalPotential(ctrl.home.id, args).then(function (result) {
          if (!result) {
            useStaticFallback();
            return;
          }

          if (!result.property_stats || result.error) {
            RollbarService.error('Bad AirDNA response', Object.assign({ homeId: ctrl.home.id }, { result: result }));
            useStaticFallback();
            return;
          }

          ctrl.viewState = 'airdna';
          ctrl.potential = result.property_stats;

          utils.track('AirDNALoaded');
        }).catch(function () {
          useStaticFallback();
        });
      };

      ctrl.toggleDrawer = function () {
        ctrl.drawerOpen = !ctrl.drawerOpen;
      };
    },
    link: function link($scope, el, attrs, ctrl) {
      function isInViewport(elem) {
        var bounding = elem.getBoundingClientRect();
        var padding = 150; // number of pixels above this element that should trigger a load

        return bounding.top >= 0 && bounding.top <= ($window.innerHeight + padding || document.documentElement.clientHeight + padding);
      }

      var scrollHandler = _.throttle(function () {
        if (el && el[0] && isInViewport(el[0])) {
          ctrl.loadAirDna();
          $($window).off('scroll.airdnaScroll', scrollHandler);
        }
      }, 250);

      $($window).on('scroll.airdnaScroll', scrollHandler);
    }
  };
}]);

angular.module('homebot.directives').directive('nightlyRentalsStaticSection', ['APP_CONFIG', 'DataService', function (APP_CONFIG, DataService) {
  return {
    restrict: 'A',
    controllerAs: 'nightlyStaticCtrl',
    bindToController: {
      agent: '=',
      loans: '=',
      home: '='
    },
    scope: {},
    templateUrl: '/homes/templates/partials/nightly-rentals-static.html',

    controller: function controller() {
      var ctrl = this;
      ctrl.rentalNights = 5;
    }
  };
}]);

angular.module('homebot.directives').directive('noLoansSection', ['Dictionary', 'DataService', 'UtilService', function (Dictionary, DataService, utils) {
  return {
    restrict: 'A',
    controllerAs: 'noLoansCtrl',
    bindToController: {
      loans: '=',
      homeId: '@',
      addLoanAction: '&',
      noLoanAction: '&'
    },
    scope: {},
    templateUrl: '/homes/templates/section-no-loans.html',

    controller: function controller() {
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = { loans: ctrl.loans };
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        ctrl.helocCount = ctrl.lookup('currentHelocs').length;
      };

      ctrl.saveHomePaidInFull = function () {
        DataService.saveAnswer('isHomePaidInFull', true, ctrl.homeId).then(function () {
          ctrl.noLoanAction();
        }).catch(function (err) {
          utils.trackException('Save Answer', err);
        });
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('noLoansCtrl.loans', function (newVal) {
        ctrl.update();
      });
    }
  };
}]);

angular.module('homebot.directives').directive('notifications', ['NotificationService', 'SessionService', '$timeout', '$rootScope', function (NotificationService, SessionService, $timeout, $rootScope) {
  return {
    restrict: 'EA',
    controllerAs: 'notificationsCtrl',
    bindToController: {
      homeId: '@',
      notificationCount: '@',
      notificationsArray: '=',
      user: '='
    },
    scope: {},
    templateUrl: '/homes/templates/partials/notifications.html',

    controller: function controller() {
      var ctrl = this;
      var isHomeowner = !SessionService.isAgent();

      $rootScope.$on('NavDropdownChange', function (event, data) {
        if (data.currentDropdown === 'notifications' && ctrl.notificationsArray && ctrl.notificationCount && isHomeowner) {
          NotificationService.markNotificationsAsSeen(ctrl.user, ctrl.homeId);
          ctrl.notificationCount = 0;
        }
      });

      ctrl.setNotificationsSeen = function () {
        $timeout(function () {
          if (isHomeowner) {
            _.each(ctrl.notificationsArray, function (notification) {
              notification.is_seen = true;
            });
          }
        });
      };
    },

    link: function link($scope, el, attrs, ctrl) {}
  };
}]);

angular.module('homebot.directives').directive('pageNotification', ['$rootScope', function ($rootScope) {
  return {
    restrict: 'E',
    controllerAs: 'pageNotificationCtrl',
    scope: {},
    templateUrl: '/homes/templates/partials/page-notification.html',

    controller: function controller() {
      var ctrl = this;

      $rootScope.$on('PageNotification', function (event, data) {
        if (data.message) ctrl.message = data.message;else ctrl.clear();
      });

      ctrl.clear = function () {
        ctrl.message = '';
      };
    }
  };
}]);

angular.module('homebot.directives').directive('paidSoFarSection', ['Dictionary', 'HelperService', 'ChartService', '$rootScope', '$cookies', '$timeout', function (Dictionary, helpers, ChartService, $rootScope, $cookies, $timeout) {
  return {
    bindToController: {
      agent: '=',
      loans: '='
    },
    controllerAs: 'paidCtrl',
    restrict: 'A',
    scope: {},
    templateUrl: '/homes/templates/section-paid-so-far.html',

    controller: function controller() {
      var loans;
      var dictionary = new Dictionary();
      var paidCtrl = this;
      var isFirstLoad = true;

      paidCtrl.hasCheckedNumbers = $cookies.get('hasCheckedNumbers');

      paidCtrl.lookup = function (prop, args, home) {
        var home = { loans: loans };
        return dictionary[prop](home, args);
      };

      paidCtrl.update = function () {
        loans = _.isArray(paidCtrl.loans) ? paidCtrl.loans : [paidCtrl.loans];
        paidCtrl.chartistPaidSoFar = ChartService.chartistPaidSoFar([paidCtrl.lookup('principalPaidTotal'), paidCtrl.lookup('interestPaidTotal')]);

        if (isFirstLoad) updateFakeProperty();
      };

      $rootScope.$watch('subView', function (newVal) {
        if (newVal === 'number-entry') paidCtrl.hasCheckedNumbers = true;
      });

      paidCtrl.shouldCheckNumbers = function () {
        if (!paidCtrl.lookup('unverifiedLoans').length) return false;else if (paidCtrl.hasCheckedNumbers) return false;else return true;
      };

      // Chartist no longer updates after the
      // pageload animation. This is a hack to
      // get chartist to update after the animation.
      // TODO fix this / get rid of chartist
      function updateFakeProperty() {
        $timeout(function () {
          paidCtrl.chartistPaidSoFar.options.fakePropertyForRefresh = 1;
          isFirstLoad = false;
        }, 1000);
      }
    },

    link: function link($scope, el, attrs, paidCtrl) {

      $scope.$watch('paidCtrl.hasCheckedNumbers', function (newVal) {
        if (!helpers.isFalsey(newVal)) $cookies.put('hasCheckedNumbers', true, { expires: moment().add(1, 'year').format() });
      });

      $scope.$watchCollection('paidCtrl.loans', function (newVal) {
        paidCtrl.update();
      });
    }
  };
}]);

angular.module('homebot.directives').directive('phoneInput', [function () {
  return {
    bindToController: {
      model: '='
    },
    controllerAs: 'phoneCtrl',
    restrict: 'E',
    scope: {},
    template: '<input type="tel"\n          ng-model="phoneCtrl.model"\n          text-mask="phoneCtrl.maskOptions"\n          pattern="^\\d{3}-\\d{3}-\\d{4}$"\n          title="10 digit phone number with dashes"\n          placeholder="888-777-7777"\n        />',

    controller: function controller() {
      var ctrl = this;

      ctrl.maskOptions = {
        mask: [/[2-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      if (attrs.required !== undefined) el.find('input').attr('required', 'required');
    }
  };
}]);

angular.module('homebot.directives').directive('pmiEstimateAdjuster', [function () {
  return {
    restrict: 'A',
    controllerAs: 'pmiEstimateCtrl',
    bindToController: {
      estimate: '=',
      confirmEstimate: '&',
      setPmi: '=',
      showLoading: '='
    },
    scope: {},
    templateUrl: '/homes/templates/partials/pmi-estimate-adjuster.html',
    controller: function controller() {
      var ctrl = this;

      ctrl.pmiInput = null;
      ctrl.confirmLoading = false;

      ctrl.manualLoading = function () {
        return !ctrl.confirmLoading && ctrl.showLoading;
      };

      ctrl.confirmEstimate = function () {
        ctrl.confirmLoading = true;
        ctrl.setPmi(ctrl.estimate);
      };
    }
  };
}]);

angular.module('homebot.directives').directive('posNegClass', ['HelperService', function (helpers) {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      attrs.$observe('posNegClass', function (newVal) {
        if (helpers.isFalsey(newVal)) el.addClass('text-danger').removeClass('text-positive');else el.addClass('text-positive').removeClass('text-danger');
      });
    }
  };
}]);

angular.module('homebot.directives').directive('positiveOver', [function () {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      attrs.$observe('value', function (newVal) {
        var positiveOver = attrs.positiveOver || 0;
        positiveOver = parseInt(positiveOver);
        newVal = parseInt(newVal);

        if (newVal > positiveOver) el.addClass('text-positive').removeClass('text-danger');else el.removeClass('text-positive');
      });
    }
  };
}]);

angular.module('homebot.directives').directive('positiveUnder', [function () {
  return {
    restrict: 'A',
    link: function link(scope, el, attrs) {
      attrs.$observe('value', function (newVal) {
        var positiveUnder = attrs.positiveUnder || 0;
        positiveUnder = parseInt(positiveUnder);
        newVal = parseInt(newVal);

        if (newVal < positiveUnder) el.addClass('text-positive').removeClass('text-danger');else el.addClass('text-danger').removeClass('text-positive');
      });
    }
  };
}]);

angular.module('homebot.directives').directive('principalPaymentsSection', ['Dictionary', 'UtilService', 'PRINCIPAL_PAYMENT_OPTIONS', function (Dictionary, utils, PRINCIPAL_PAYMENT_OPTIONS) {
  return {
    restrict: 'A',
    controllerAs: 'pmtCtrl',
    bindToController: {
      agent: '=',
      homeId: '@',
      initialPayment: '@',
      loans: '=',
      userId: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/section-principal-payments.html',

    controller: function controller() {
      var dictionary = new Dictionary();
      var ctrl = this;
      var loans = [];

      function getCorrectLoan() {
        return [dictionary.highestRateLoan({ loans: ctrl.loans })];
      };

      ctrl.lookup = function (prop, args, home) {
        if (!loans || !loans.length) return '';

        home = home || { loans: loans };
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        loans = getCorrectLoan();

        if (!ctrl.payment) {
          var payment = ctrl.lookup('initialDIYPayment');
          ctrl.payment = PRINCIPAL_PAYMENT_OPTIONS[0];

          _.find(PRINCIPAL_PAYMENT_OPTIONS, function (option) {
            if (option > payment) return true;
            ctrl.payment = option;
          });
        }
      };

      ctrl.hideTip = function () {
        ctrl.tipOpen = false;
      };

      ctrl.showTip = function () {
        ctrl.tipOpen = true;
      };

      ctrl.toggleTip = function () {
        ctrl.tipOpen = !ctrl.tipOpen;
      };

      ctrl.isTipOpen = function () {
        return ctrl.tipOpen;
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('pmtCtrl.loans', ctrl.update);
    }
  };
}]);

angular.module('homebot.directives').directive('pro', ['HelperService', '$state', 'DataService', function (helpers, $state, DataService) {
  return {
    restrict: 'A',
    controllerAs: 'proCtrl',
    bindToController: {
      mlsRea: '=',
      agent: '=',
      brokerageName: '@',
      isLenderAdmin: '@'
    },
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      return attrs.templateUrl || '/homes/templates/partials/pro-card-inner.html';
    },

    controller: function controller() {
      var ctrl = this;

      ctrl.startDate = moment().subtract(30, 'days').startOf('day').toDate();

      if (!helpers.isFalsey(ctrl.isLenderAdmin)) ctrl.isLenderAdmin = true;

      function mapAgentToPro(agent) {
        var pro = _.clone(agent);

        pro.profile_url = pro.website;

        if (ctrl.brokerageName) pro.office = { brokerage: { name: ctrl.brokerageName } };

        return pro;
      };

      function updateJobTitle() {
        if (!ctrl.pro || ctrl.pro && ctrl.pro.jobTitle) return;

        ctrl.pro.jobTitle = ctrl.isLender() ? 'Your Mortgage Pro' : 'Real Estate Agent';
      };

      ctrl.setupOfficeAddress = function () {
        if (ctrl.agent && ctrl.agent.office && ctrl.agent.office.brokerage && ctrl.agent.office.brokerage.showAddress) {

          ctrl.officeAddressFirstLine = ctrl.agent.office.address.street;

          ctrl.officeAddressSecondLine = ctrl.agent.office.address.city + ', ' + ctrl.agent.office.address.state + ' ' + ctrl.agent.office.address.zip;

          ctrl.officeAddressFull = ctrl.officeAddressFirstLine + ', ' + ctrl.officeAddressSecondLine;

          ctrl.showOfficeAddress = true;
        } else {
          ctrl.showOfficeAddress = false;
        };
      };

      ctrl.isLender = function () {
        if (ctrl.agent && ctrl.agent.type === 'mortgage') return true;

        return false;
      };

      ctrl.update = function () {
        if (ctrl.mlsRea) ctrl.pro = mapAgentToPro(ctrl.mlsRea);else ctrl.pro = ctrl.agent;

        updateJobTitle();
      };

      ctrl.updateAgentData = function () {
        ctrl.updatingAgentData = true;

        DataService.updateRealEstateAgent(ctrl.pro.id).then(function (agent) {
          ctrl.updatingAgentData = false;

          if (agent.photo) agent.photo = agent.photo + '?' + _.random(1000); // bust photo cache
          ctrl.mlsRea = agent;
        });
      };

      ctrl.setupOfficeAddress();
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watch('proCtrl.mlsRea', ctrl.update);
      $scope.$watch('proCtrl.agent', ctrl.update);
    }
  };
}]);

angular.module('homebot.directives').directive('refiPoint', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'AE',
    controllerAs: 'refiPointCtrl',
    bindToController: {
      loans: '=',
      rateType: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/partials/refi-point.html',

    controller: function controller() {
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = { loans: ctrl.loans };
        args = args || {};
        args.rateType = ctrl.rateType;
        return dictionary[prop](home, args);
      };

      ctrl.update = function () {
        ctrl.savingsTotal = ctrl.lookup('refiSavingsTotal');
        ctrl.paymentSavings = ctrl.lookup('refiPaymentSavingsMonthly');
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchCollection('refiPointCtrl.loans', ctrl.update);
    }
  };
}]);

angular.module('homebot.directives').directive('refiSection', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'refiCtrl',
    bindToController: {
      agent: '=',
      loans: '=',
      company: '=',
      homeId: '@',
      userId: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/section-refi.html',

    controller: function controller() {
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = {
          loans: _.isArray(ctrl.loans) ? ctrl.loans : [ctrl.loans],
          agent: [ctrl.agent]
        };
        return dictionary[prop](home, args);
      };
    }
  };
}]);

angular.module('homebot.directives').directive('rentalPotentialChart', ['$timeout', function ($timeout) {
  return {
    restrict: 'E',
    controllerAs: 'rentalPotentialChartCtrl',
    bindToController: {
      rentalPotential: '=',
      chartType: '@',
      percentage: '@'
    },
    scope: {},
    template: '\n      <div class="chart-container chart-container--bar-chart">\n        <svg class="bar-chart"></svg>\n      </div>\n      ',

    controller: function controller() {
      var ctrl = this;

      ctrl.update = function () {
        if (!ctrl.chart) return;

        var data = void 0;

        data = AirDnaChartSerializer[ctrl.chartType](ctrl.rentalPotential, parseFloat(ctrl.percentage));

        ctrl.chart.update(data);
      };

      $timeout(function () {
        ctrl.chart = new BarChart(ctrl.el);
        ctrl.update();
      });
    },

    link: function link(scope, el, attrs, ctrl) {
      ctrl.el = el.find('svg')[0];

      el.on('$destroy', function () {
        if (ctrl.chart) ctrl.chart.destroy();
      });

      scope.$watch('rentalPotentialChartCtrl.chartType', function (newVal, oldVal) {
        if (newVal) ctrl.update();
      });

      scope.$watch('rentalPotentialChartCtrl.percentage', function (newVal, oldVal) {
        if (newVal) ctrl.update();
      });
    }
  };
}]);

angular.module('homebot.directives').directive('reverseMortgageSection', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'reverseMortgageCtrl',
    bindToController: {
      agent: '=',
      home: '=',
      userId: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/section-reverse-mortgage.html',

    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.lookup = function (prop) {
        return dictionary[prop](ctrl.home);
      };
    }
  };
}]);

angular.module('homebot.directives').directive('scrollTo', ['ScrollService', function (ScrollService) {
  return {
    restrict: 'A',
    controllerAs: 'scrollToCtrl',
    bindToController: {
      scrollTo: '@'
    },
    scope: {},
    controller: function controller() {},
    link: function link(scope, el, attrs, ctrl) {
      el.on('click', function (e) {
        ScrollService.scroll({ target: attrs.scrollTo });
        e.preventDefault();
      });
    }
  };
}]);

angular.module('homebot.directives').directive('sectionError', [function () {
  return {
    restrict: 'E',
    controllerAs: 'errorCtrl',
    bindToController: {
      content: '@'
    },
    templateUrl: '/homes/templates/partials/section-error.html',
    controller: function controller() {},
    scope: {},
    link: function link() {}
  };
}]);

angular.module('homebot.directives').directive('sectionLoader', function () {
  return {
    restrict: 'E',
    controllerAs: 'loaderCtrl',
    bindToController: {
      loading: '=',
      content: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/partials/section-loader.html',
    controller: function controller() {
      var ctrl = this;
    },
    link: function link($scope, el, attrs) {}
  };
});

angular.module('homebot.directives').directive('pmiSection', ['DataService', 'Dictionary', 'UtilService', 'PageNotificationService', 'LoanFormParser', 'RollbarService', function (DataService, Dictionary, utils, PageNotificationService, loanFormParser, RollbarService) {

  return {
    restrict: 'AE',
    controllerAs: 'pmiCtrl',
    bindToController: {
      agent: '=',
      home: '=',
      homeValue: '@',
      userId: '@',
      onSave: '&'
    },
    scope: {},
    templateUrl: '/homes/templates/section-pmi.html',
    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      var refresh = function refresh() {
        ctrl.loan = loanFormParser.parseForEditing(ctrl.home.currentLoans[0]);
        ctrl.manualPMITotal = dictionary.conventionalPmiMonthlyTotal(ctrl.home);
        ctrl.estimatedPMITotal = dictionary.estimatedPmiMonthlyTotal(ctrl.home);
        ctrl.loading = false;
      };

      ctrl.refresh = refresh;

      refresh();

      utils.track(ctrl.manualPMITotal ? 'KnownPMILoaded' : 'EstPMILoaded');

      ctrl.lookup = function (prop) {
        return dictionary[prop](ctrl.home);
      };

      ctrl.setPmi = function (value) {
        var loan = loanFormParser.parse(ctrl.loan);
        ctrl.loading = true;
        loan.pmi_monthly = value;

        DataService.saveLoan(loan, ctrl.loan.id).then(function () {
          ctrl.onSave();
          ctrl.loading = false;
        }).catch(function (e) {
          PageNotificationService.error('There was an error saving your PMI.');
          RollbarService.error('Save PMI', e);
          ctrl.loading = false;
        });
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watch('pmiCtrl.home.currentLoans', function () {
        ctrl.refresh();
      });
    }
  };
}]);

angular.module('homebot.directives').directive('sectionSuccess', ['$timeout', function ($timeout) {
  return {
    restrict: 'E',
    controllerAs: 'successCtrl',
    bindToController: {
      content: '@'
    },
    templateUrl: '/homes/templates/partials/section-success.html',
    controller: function controller() {},
    scope: {},
    link: function link() {}
  };
}]);

angular.module('homebot.directives').directive('supportLink', ['UtilService', function (utils) {
  return {
    restrict: 'AE',
    controllerAs: 'supportCtrl',
    bindToController: {
      message: '@'
    },
    template: '',
    scope: {},
    controller: function controller() {
      var ctrl = this;
      ctrl.message = ctrl.message || '';

      ctrl.contactSupport = function () {
        if (window.Intercom) window.Intercom('showNewMessage', ctrl.message);

        utils.track('ContactSupport');
      };
    },

    link: function link(scope, el, attrs, ctrl) {
      el.on('click', function (e) {
        ctrl.contactSupport();
        e.preventDefault();
      });
    }
  };
}]);

angular.module('homebot.directives').directive('toggleSubscribe', ['DataService', '$timeout', function (DataService, $timeout) {
  return {
    controllerAs: 'subscribeCtrl',
    bindToController: {
      onSuccess: '&',
      user: '='
    },
    restrict: 'A',
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      return attrs.templateUrl || '/homes/templates/partials/toggle-subscribe.html';
    },
    controller: function controller() {
      var ctrl = this;

      function success(user) {
        // changed signifies that it's not a fresh page load
        // and the messaging should be different
        ctrl.changed = true;

        ctrl.user = user;

        if (ctrl.onSuccess) ctrl.onSuccess();

        ctrl.loading = false;
      };

      function error(err) {
        ctrl.error = err;
        ctrl.loading = false;
      };

      ctrl.toggle = function () {
        var endpoint = ctrl.user.digestEmailUnsubscribed ? 'subscribe' : 'unsubscribe';
        ctrl.loading = true;
        ctrl.error = null;

        DataService.emailSubscribe[endpoint](ctrl.user.id).then(success).catch(error);

        return false;
      };
    }
  };
}]);

angular.module('homebot.directives').directive('toggle', [function () {
  return {
    restrict: 'E',
    controllerAs: 'toggleCtrl',
    bindToController: {
      falseLabel: '@',
      trueLabel: '@',
      model: '=',
      defaultValue: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/partials/toggle.html',

    controller: ['$scope', function ($scope) {
      var ctrl = this;

      ctrl.falseLabel = ctrl.falseLabel || 'Off';
      ctrl.trueLabel = ctrl.trueLabel || 'On';
    }]
  };
}]);

angular.module('homebot.directives').directive('videoRecorder', ['$timeout', 'HelperService', 'PageNotificationService', 'RollbarService', function ($timeout, HelperService, PageNotificationService, RollbarService) {
  return {
    controllerAs: 'recorderCtrl',
    bindToController: {
      bbApiKey: '=',
      home: '='
    },
    restrict: 'E',
    scope: {},
    templateUrl: '/homes/templates/partials/video-recorder.html',
    controller: function controller() {
      var ctrl = this;
      var bbInstance;
      var video;

      ctrl.videoTitle = 'Homebot - ' + ctrl.home.address.street + ' - ' + moment().format('M/D/YY');
      ctrl.emailToAddress = _.map(ctrl.home.users, 'email').join(', ');
      ctrl.emailSubject = 'A tip about your ' + moment().format('MMMM') + ' Homebot report';
      ctrl.emailBodyContent = 'The market is changing rapidly. I\'ve outlined a few great opportunities for you here based on your current situation.';

      ctrl.launchVideoRecorder = function () {
        if (bbInstance) return;

        bbInstance = new BBCore({ accessToken: ctrl.bbApiKey });

        bbInstance.onError(function (errorInfo) {
          var errorMessage = errorInfo.message ? errorInfo.message : errorInfo;
          PageNotificationService.error('An error occurred. Please contact us if this continues. ' + errorMessage);
          RollbarService.error('BBCore Error:', errorInfo);
        });

        bbInstance.startVideoRecorder({ target: '#recorder', width: 360 }, function (videoInfo) {
          video = videoInfo;
          $timeout(function () {
            ctrl.toggleVideoSaveForm(true);
          }, 0);
        });
      };

      ctrl.saveVideo = function () {
        if (!ctrl.videoTitle) return;
        ctrl.saving = true;

        bbInstance.saveRecordedVideo(ctrl.videoTitle, video.videoId, video.filename, function (data) {
          ctrl.toggleVideoSaveForm();
          ctrl.saving = false;

          $timeout(ctrl.toggleEmailForm, 0);
        });
      };

      ctrl.sendVideoEmail = function () {
        ctrl.sending = true;

        var bodyContent = ctrl.emailBodyContent ? ctrl.emailBodyContent + '<br /><br />' : '';

        var digestUrl = window.location.origin + window.location.pathname;
        var emailParams = {
          subject: ctrl.emailSubject,
          toAddresses: ctrl.emailToAddress.replace(/([\s,;,\,]+)/g, '; '),
          bodyContent: bodyContent + '<a href="' + digestUrl + '">View your Homebot Report &rsaquo;&rsaquo;</a>'
        };

        bbInstance.videoQuickSend({
          subject: emailParams.subject,
          video_id: video.videoId,
          email_addresses: emailParams.toAddresses,
          mobile_message: emailParams.bodyContent
        }, function () {
          ctrl.sending = false;
          var emailAddresses = emailParams.toAddresses.replace(/([\s,;,\,]+)/g, ' & ');
          $timeout(ctrl.toggleEmailForm, 0);
          PageNotificationService.success('Your video was sent to ' + emailAddresses + '!');
        });
      };

      ctrl.toggleRecorder = function () {
        ctrl.showRecorder = !ctrl.showRecorder;
        if (ctrl.showRecorder) ctrl.launchVideoRecorder();
      };

      ctrl.toggleEmailForm = function () {
        ctrl.showEmailForm = !ctrl.showEmailForm;
      };

      ctrl.toggleVideoSaveForm = function (show) {
        if (_.isBoolean(show)) {
          ctrl.showVideoSaveForm = show;
          return;
        }

        ctrl.showVideoSaveForm = !ctrl.showVideoSaveForm;
      };
    }
  };
}]);

angular.module('homebot.directives').directive('yourLoansSentence', ['Dictionary', '$filter', function (Dictionary, $filter) {
  return {
    restrict: 'A',
    controllerAs: 'sentenceCtrl',
    bindToController: {
      loans: '=',
      long: '@'
    },
    scope: {},
    templateUrl: '/homes/templates/your-loans-sentence.html',

    controller: function controller() {
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        var home = { loans: ctrl.loans };
        return dictionary[prop](home, args);
      };

      ctrl.loanAmounts = function () {
        return _.map(_.pluck(ctrl.loans, 'amount'), function (amount) {
          return $filter('money')(amount);
        }).join(' and ');
      };
    }
  };
}]);

if (typeof require !== 'undefined' && typeof _ === 'undefined') {
  var _ = require('lodash');
  var moment = require('moment');
}

var ActivityDictionary = function ActivityDictionary(undefined) {

  return {
    digestSent: function digestSent(stream) {
      return _.filter(stream, { event: 'sent' }).length;
    },

    sortAndGroupEvents: function sortAndGroupEvents(stream) {
      var THIS = this;
      var stream = _.cloneDeep(stream);

      stream = _.groupBy(stream, function (event) {
        return moment(event.created).format('YYYY-MM-DD') + event.source + event.event + event.userId;
      });

      _.each(stream, function (eventSet, i) {
        stream[i] = THIS.sortEvents(eventSet);
      });

      return _.sortBy(stream, function (eventSet) {
        return -moment(eventSet[0].created).format('YYYYMMDDHHmmss');
      });
    },

    sortEvents: function sortEvents(stream) {
      return _.sortBy(stream, function (event) {
        return -moment(event.created).format('YYYYMMDDHHmmss');
      });
    }
  };
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = new ActivityDictionary();
} else if (typeof window !== 'undefined') {
  window.ActivityDictionary = ActivityDictionary;
}

// Used to lookup data from the api
// responses and process if necessary.
// Can be shared with other apps.

// @var home = a mortgage response from the api
if (typeof require !== 'undefined' && typeof _ === 'undefined') {
  var _ = require('lodash');
  var moment = require('moment');
  var finance = require('./Finance.js');
  var Helpers = require('./Helpers.js');
}

var LTV_PMI_ESTIMATE_MAP = {
  // termYears: {
  //   ltvPercentileCeil: pmiPercent
  // }
  '30': {
    '95': 0.0062,
    '90': 0.0044,
    '85': 0.0027,
    '80': 0.0027
  },
  '15': {
    '95': 0.0057,
    '90': 0.0039,
    '85': 0.0022,
    '80': 0.0022
  }
};

var GlobalDictionary = function GlobalDictionary(undefined) {

  return {

    currentLoanWithMax: 'amount', //amount, date, rate

    loanStatus: 'current', //current, expired

    init: function init(args) {
      if (args) {
        if (args.currentLoanWithMax && ['amount', 'date', 'rate'].indexOf(args.currentLoanWithMax) !== -1) this.currentLoanWithMax = args.currentLoanWithMax;
        if (args.loanStatus && ['current', 'expired'].indexOf(args.loanStatus) !== -1) this.loanStatus = args.loanStatus;
      }
    },

    availableEquity: function availableEquity(home, factor) {
      var homeValue = this.avm(home);
      var equity = this.equity(home);

      var downpaymentFactor = factor || 0.3;
      var estimatedDownpayment = homeValue * downpaymentFactor;
      var availableEquity = equity - estimatedDownpayment;

      return availableEquity > 0 ? availableEquity : 0;
    },

    avm: function avm(home) {
      return this.cma(home) || this.avmWithoutCMA(home) || false;
    },

    avmDiffPercent: function avmDiffPercent(home) {
      if (!home.avm || !home.avm.length) return null;

      var avms = [].concat(_toConsumableArray(home.avm)).filter(function (avm) {
        return avm.type === 'avm';
      });
      avms = Helpers.sortByDate(avms, 'updated');

      if (!avms.length || avms.length < 2) return null;

      return (avms[0].amount / avms[1].amount - 1) * 100;
    },

    avmWithoutCMA: function avmWithoutCMA(home) {
      if (!home.avm || !home.avm.length) return 0;

      var avms = home.avm.filter(function (loan) {
        return loan.rental !== true;
      });
      avms = Helpers.sortByDate(avms, 'updated');

      return this._avmValueFromSource(avms, 'sitex') || this._avmValueFromSource(avms, 'realtytrac') || this._avmValueFromSource(avms, 'zillow') || 0;
    },

    _avmValueFromSource: function _avmValueFromSource(avms, source) {
      avms = avms.filter(function (avm) {
        return avm.source === source;
      });
      if (avms.length) return avms[0].amount;
      return 0;
    },

    cma: function cma(home) {
      if (_.isEmpty(home.cma)) return 0;

      var avmWithoutCMA = this.avmWithoutCMA(home);

      if (!avmWithoutCMA) return home.cma.amount;else if (home.cma.amount === home.cma.diff) return avmWithoutCMA;

      return avmWithoutCMA + parseInt(home.cma.diff, 10);
    },

    cmaBuyersAgentPreferred: function cmaBuyersAgentPreferred(home) {
      if (Helpers.isFalsey(home.answers.cmaBuyersAgentPreferred)) return false;

      return true;
    },

    cmaBuyersAgentUnknown: function cmaBuyersAgentUnknown(home) {
      return typeof home.answers.cmaBuyersAgentPreferred === 'undefined';
    },

    cmaDone: function cmaDone(home) {
      return Boolean(this.hasRealCMA(home) && !this.needsCMA(home));
    },

    appreciation: function appreciation(home) {
      return this.avm(home) - home.soldPrice;
    },

    appreciationSentence: function appreciationSentence(home) {
      if (!home.soldPrice) return '';

      var appreciationPercent = Helpers.getAppreciationPercent(this.avm(home), home.soldPrice);

      if (appreciationPercent > 10) return "That's up " + appreciationPercent + "% from when you bought it. Nice!";else if (appreciationPercent > 0) return "That's up " + appreciationPercent + "% from when you bought it.";else if (appreciationPercent < 0) return "Down " + Math.abs(appreciationPercent) + "% from when you bought it.";else return '';
    },

    buyingPowerSecondHome: function buyingPowerSecondHome(home) {
      var downpaymentFactor = 0.3;
      var availableEquity = this.availableEquity(home, downpaymentFactor);
      var buyingPower = availableEquity * (1 / downpaymentFactor);

      return buyingPower >= 50000 ? buyingPower : 0;
    },

    buyingPowerTradeUp: function buyingPowerTradeUp(home) {
      var downpaymentFactor = 0.25;
      var homeValue = this.avm(home);
      var equity = this.equity(home);
      var tradeUpPower = equity * (1 / downpaymentFactor);

      return equity > 0 ? tradeUpPower : 0;
    },

    cashoutVal: function cashoutVal(home, args) {
      var ltv = args && args.ltv ? args.ltv : .8;
      var cashout = ltv * this.avm(home) - this.outstandingPrincipalTotal(home);

      return cashout > 0 ? cashout : 0;
    },

    cashoutMinLTV: function cashoutMinLTV(home) {
      return this.cashoutLTVZeroBound(home) + 1;
    },

    cashoutLTVZeroBound: function cashoutLTVZeroBound(home) {
      return Math.round(this.outstandingPrincipalTotal(home) / this.avm(home) * 100);
    },

    cmaSourceAgent: function cmaSourceAgent(home) {
      if (!this.hasRealCMA(home) || !home.cma.sourceObject) return undefined;

      if (home.cma.sourceObject.type === 'mortgage') return undefined;

      return home.cma.sourceObject;
    },

    hasAutoCMA: function hasAutoCMA(home) {
      return Boolean(home.cma && home.cma.systemGenerated);
    },

    hasRealCMA: function hasRealCMA(home) {
      return Boolean(!_.isEmpty(home.cma) && home.cma.type === 'cma' && !this.hasAutoCMA(home));
    },

    conventionalPmiMonthlyTotal: function conventionalPmiMonthlyTotal(home) {
      if (!home.loans || !home.loans.length) return 0;

      return _.chain(home.loans).filter(function (loan) {
        return loan.status === 'current' && loan.finance_type !== 'FHA';
      }).sum('pmi_monthly').value();
    },

    fhaPmiMonthlyTotal: function fhaPmiMonthlyTotal(home) {
      var maxLoan = this.maxLoan(home);

      if (!maxLoan || maxLoan.finance_type !== 'FHA') return 0;

      var pmiRate = this.pmiRateForFHA(maxLoan);

      if (pmiRate) {
        var pmiForFHA = maxLoan.amount * pmiRate;
        return pmiForFHA / 12;
      }

      return 0;
    },

    estimatedPmiMonthlyTotal: function estimatedPmiMonthlyTotal(home) {
      var currentLoans = this.currentLoans(home);

      if (currentLoans.length !== 1) {
        return 0;
      }

      var loanAmount = currentLoans[0].amount;
      var originalLTV = loanAmount / home.soldPrice * 100;
      var termYears = this.termYears(home);

      var pmiRate = this.getLtvPmiEstimateRate(termYears, originalLTV);
      var pmiAnnual = pmiRate * loanAmount;

      return Math.round(pmiAnnual / 12);
    },

    getLtvPmiEstimateRate: function getLtvPmiEstimateRate(loanTerm, originalLtv) {
      if (originalLtv <= 80) {
        return 0;
      }

      var ceilLTV = Math.ceil(originalLtv / 5) * 5;
      var maximumPmiEstimateLTV = Math.min(ceilLTV, 95);

      return _.get(LTV_PMI_ESTIMATE_MAP, [loanTerm, maximumPmiEstimateLTV]);
    },

    currentHelocs: function currentHelocs(home) {
      return _.filter(this.loans(home), function (loan) {
        return loan.status === 'current' && loan.loan_type === 'HELOC';
      });
    },

    currentLoans: function currentLoans(home) {
      return _.where(this.loans(home), { status: 'current' });
    },

    currentLoansNoHelocs: function currentLoansNoHelocs(home) {
      return _.filter(this.loans(home), function (loan) {
        return loan.status === 'current' && loan.loan_type !== 'HELOC';
      });
    },

    customTermsEnabled: function customTermsEnabled(home) {
      return Boolean(home.agent[0].office.brokerage.offersCustomTerms);
    },

    //TODO if current loan is refi then can't use originalLoanAmount since this returns the current loan sum
    //either need to change originalLoanAmount or use expired loans to calc originalLoanAmount
    downPayment: function downPayment(home) {
      return home.soldPrice - this.originalLoanAmountTotal(home);
    },

    eligibleRefiLoans: function eligibleRefiLoans(home) {
      function nonRecentLoansFilter(loan) {
        var fiveMonthsAgo = moment().subtract(5, 'months');
        return moment(loan.date).isBefore(fiveMonthsAgo);
      };

      return this.currentLoansNoHelocs(home).filter(nonRecentLoansFilter);
    },

    equity: function equity(home) {
      var homeValue = this.avm(home);
      var loans = this.currentLoansNoHelocs(home);
      var debt = this.outstandingPrincipalTotal({ loans: loans });

      if (!loans.length) return homeValue;

      return homeValue - debt;
    },

    equityPercent: function equityPercent(home) {
      var homeValue = this.avm(home);
      var loans = this.currentLoansNoHelocs(home);
      var debt = this.outstandingPrincipalTotal({ loans: loans });

      if (!loans.length) return 100;

      return (1 - debt / homeValue) * 100;
    },

    expiredLoans: function expiredLoans(home) {
      return _.where(this.loans(home), { status: 'expired' });
    },

    extraPaymentSavingsTotal: function extraPaymentSavingsTotal(home, args) {
      return this.interestForFullLoanTotal(home) - this.extraPaymentObj(home, args).interest_paid;
    },

    extraPaymentObj: function extraPaymentObj(home, args) {
      if (!args || !args.amt) throw 'args.amt is required';
      return finance.getMaturityDate(this.originalLoanAmountTotal(home), this.periods(home), this.interestRate(home), new Date(this.originalLoanDate(home)), args.amt, false);
    },

    extraPaymentYears: function extraPaymentYears(home, args) {
      var extraPayment = this.extraPaymentObj(home, args);
      var years = extraPayment.time_savings.years;
      var months = extraPayment.time_savings.months;

      if (months > 5) years++;

      return years;
    },

    _hasEligibleRefiLoans: function _hasEligibleRefiLoans(home) {
      return Boolean(this.eligibleRefiLoans(home).length);
    },

    hasRecentLoan: function hasRecentLoan(home) {
      return _.some(home.loans, function (loan) {
        var fiveMonthsAgo = moment().subtract(5, 'months');
        return moment(loan.date).isAfter(fiveMonthsAgo);
      });
    },

    hasRecentClosedEndLoan: function hasRecentClosedEndLoan(home) {
      var currentLoansNoHelocs = this.currentLoansNoHelocs(home);
      return this.hasRecentLoan({ loans: currentLoansNoHelocs });
    },

    hasUpToDateCMA: function hasUpToDateCMA(home) {
      if (!this.hasRealCMA(home)) return false;

      var requestDate = moment(home.hasRequestedCMA).subtract(24, 'hours');

      if (home.hasRequestedCMA && moment(home.cma.updated).isBefore(requestDate)) return false;

      return true;
    },

    highestRateLoan: function highestRateLoan(home) {
      return _.max(_.where(home.loans, { 'status': 'current' }), function (loan) {
        return loan.rate || loan.rateEstimated;
      });
    },

    initialDIYPayment: function initialDIYPayment(home) {
      var extraPayment = Math.round(this.monthlyPaymentTotal(home) * .15 / 100) * 100;
      return extraPayment >= 100 ? extraPayment : 100;
    },

    interestForFullLoanTotal: function interestForFullLoanTotal(home) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'facts.totalInterest');
      return 0;
    },

    interestStatus: function interestStatus(home) {
      if (this.hasRecentClosedEndLoan(home)) return 'recentLoans';else if (this.refiSavingsTotal(home, { rateType: 'FIX15YR' }) < 0) return 'good';else return 'bad';
    },

    interestPaidTotal: function interestPaidTotal(home) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'progress.interest_paid');
      return 0;
    },

    interestRate: function interestRate(home) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.rate || maxLoan.rateEstimated;

      return this.marketRateOnSoldDate(home);
    },

    interestSavings: function interestSavings(home) {
      var savings = 0;
      if (this.extraPaymentSavingsTotal(home) > 0) savings += this.extraPaymentSavingsTotal(home);
      if (this.refiSavingsTotal(home) > 0) savings += this.refiSavingsTotal(home);

      return savings;
    },

    isConsolidation: function isConsolidation(home) {
      return home.loans.length > 1;
    },

    isFHA: function isFHA(home) {
      if (!home.loans || !home.loans.length) return false;

      return this.maxLoan(home).finance_type === 'FHA';
    },

    latestAvmIsCma: function latestAvmIsCma(home) {
      if (!home.avm || !home.avm.length) return false;

      var avms = [].concat(_toConsumableArray(home.avm));
      avms = Helpers.sortByDate(avms, 'updated');

      return avms[0].type === 'cma';
    },

    loans: function loans(home) {
      return home && home.loans && home.loans.length ? home.loans : [];
    },

    ltvPercent: function ltvPercent(home) {
      var homeValue = this.avm(home);
      var loans = this.currentLoansNoHelocs(home);
      var debt = this.outstandingPrincipalTotal({ loans: loans });

      return debt / homeValue * 100;
    },

    marketRateOnSoldDate: function marketRateOnSoldDate(home) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.rate || maxLoan.rateEstimated;

      return '';
    },

    maturityDate: function maturityDate(home) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.maturity_date.nochange.date;

      return '';
    },

    maxLoan: function maxLoan(home) {
      var maxLoan = _.max(_.where(home.loans, { 'status': this.loanStatus }), this.currentLoanWithMax);

      if (!_.isEmpty(maxLoan)) return maxLoan;else return null;
    },

    monthlyPaymentEscrow: function monthlyPaymentEscrow(home) {
      return 0;
    },

    monthlyPaymentInterestTotal: function monthlyPaymentInterestTotal(home, args) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'payment.interest');
      return 0;
    },

    monthlyPaymentPrincipalTotal: function monthlyPaymentPrincipalTotal(home, args) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'payment.principal');
      return 0;
    },

    monthlyPaymentTotal: function monthlyPaymentTotal(home) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'payment.total');
      return 0;
    },

    needsCMA: function needsCMA(home) {
      return Boolean(home.hasRequestedCMA && !this.hasUpToDateCMA(home));
    },

    nmlsLoanDescriptors: function nmlsLoanDescriptors(home) {
      var descriptors = _.reduce(home.loans, function (statuses, loan) {
        if (!loan.lo_nmls) return statuses;

        if (loan.refi === true) statuses.push('Refi');else statuses.push('Purchase');

        return statuses;
      }, []);

      if (descriptors.length) return descriptors.join(', ');

      return 'Unknown loan type';
    },

    originalLoanAmountTotal: function originalLoanAmountTotal(home) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'amount');
      return home.soldPrice;
    },

    originalLoanDate: function originalLoanDate(home) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.date;

      return home.soldDate;
    },

    outstandingInterestTotal: function outstandingInterestTotal(home) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'progress.interest_left');
      return 0;
    },

    outstandingPrincipalTotal: function outstandingPrincipalTotal(home) {
      if (home.loans && home.loans.length) return _.sum(_.where(home.loans, { 'status': this.loanStatus }), 'progress.principal_left');
      return 0;
    },

    ownershipPlan: function ownershipPlan(home) {
      return home.ownershipPlan || '';
    },

    ownershipPercentage: function ownershipPercentage(home) {
      return (this.avm(home) - this.outstandingPrincipalTotal(home)) / this.avm(home) * 100;
    },

    periods: function periods(home) {
      return this.termYears(home) * 12;
    },

    principalPaidTotal: function principalPaidTotal(home) {
      if (home.loans && home.loans.length) return _.sum(_.filter(home.loans, { status: 'current' }), 'progress.principal_paid');
      return 0;
    },

    pmiTagline: function pmiTagline(home) {
      var ltvPercent = this.ltvPercent(home);

      if (ltvPercent > 82) return 'Not yet.';

      if (ltvPercent <= 82 && ltvPercent >= 80) return 'Soon. Maybe now.';

      return 'Maybe now.';
    },

    pmiRateForFHA: function pmiRateForFHA(loan) {
      if (!loan.date) return 0;

      if (moment(loan.date).isBetween('2013-06-30', '2015-01-01')) return .0135;

      if (moment(loan.date).isAfter('2014-12-31')) return .0085;

      return 0;
    },

    refiAPR: function refiAPR(home, args) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.refiToday[args.rateType].APR;

      return 0;
    },

    refiFee: function refiFee(home, args) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.refiToday[args.rateType].fee;

      return 0;
    },

    refiRate: function refiRate(home, args) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.refiToday[args.rateType].rate;

      return 0;
    },

    refiPaymentSavingsMonthly: function refiPaymentSavingsMonthly(home, args) {
      var pmiPaymentsForFHA = this.fhaPmiMonthlyTotal(home);

      return this.monthlyPaymentTotal(home) + pmiPaymentsForFHA - this.refiPaymentMonthly(home, args);
    },

    refiPeriods: function refiPeriods(home, args) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.refiToday[args.rateType].periods;
    },

    remainingPeriods: function remainingPeriods(home) {
      var periods = this.periods(home);
      var maxLoan = this.maxLoan(home);

      if (periods && maxLoan && maxLoan.date) {
        var curentMonth = moment().startOf('month');
        var loanStartingMonth = moment(maxLoan.date).startOf('month');
        var previousPeriods = curentMonth.diff(loanStartingMonth, 'months');
        return periods - previousPeriods;
      }

      return 0;
    },

    refiSavingsTotal: function refiSavingsTotal(home, args) {
      var rate = args && args.rate ? args.rate : this.refiRate(home, args);
      var consolidationInterest = finance.calculateInterest(this.outstandingPrincipalTotal(home), this.refiPeriods(home, args), rate, new Date(), 0, false);

      var pmiPaymentsForFHA = this.fhaPmiMonthlyTotal(home) * this.remainingPeriods(home);

      return -(consolidationInterest - (this.outstandingInterestTotal(home) + pmiPaymentsForFHA));
    },

    refiPaymentMonthly: function refiPaymentMonthly(home, args) {
      var rate = args && args.rate ? args.rate : this.refiRate(home, args);
      return finance.calculatePayment(this.outstandingPrincipalTotal(home), this.refiPeriods(home, args), rate);
    },

    reverseMortgageEnabled: function reverseMortgageEnabled(home) {
      return Boolean(home.agent[0].office.brokerage.showReverseMortgage);
    },

    reverseMortgageQualified: function reverseMortgageQualified(home) {
      var equityPercent = this.equityPercent(home);

      var homeownerAgeQualified = _.some(home.users, 'reverseMortgage');

      if (equityPercent >= 50 && homeownerAgeQualified) {
        return true;
      } else {
        return false;
      }
    },

    sellingAgent: function sellingAgent(home) {
      try {
        if (home.sellingAgent.datasources.rets.status === 'success') return home.sellingAgent;
        return null;
      } catch (e) {
        return null;
      };
    },

    shouldRefi: function shouldRefi(home) {
      return this.refiSavingsTotal(home) > 0;
    },

    show20YrRefi: function show20YrRefi(home) {
      if (this.monthsLeft(home) <= 22.5 * 12 && home.loans[0].refiToday.FIX20YR && !this.customTermsEnabled(home)) return true;else return false;
    },

    show25YrRefi: function show25YrRefi(home) {
      if (this.monthsLeft(home) > 22.5 * 12 && home.loans[0].refiToday.FIX25YR && !this.customTermsEnabled(home)) return true;else return false;
    },

    showCustomRefi: function showCustomRefi(home) {
      if (this.yearsLeft(home) < 18 || this.yearsLeft(home) > 27 || !this.customTermsEnabled(home)) return false;else return true;
    },

    showCashoutRefi: function showCashoutRefi(home) {
      if (!this.currentLoansNoHelocs(home).length) return true;

      home = _.cloneDeep(home);
      home.loans = this.eligibleRefiLoans(home);

      return this._hasEligibleRefiLoans(home) && this.cashoutVal(home) > 5000;
    },

    showAvmDiffWarning: function showAvmDiffWarning(home) {
      var diffPercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

      return !this.showNonDisclosureStateWarning(home) && !this.latestAvmIsCma(home) && home.metadata.avmDiffPercent > diffPercent;
    },

    showBuyingPowerSection: function showBuyingPowerSection(home) {
      if (!this.currentLoansNoHelocs(home).length) return true;

      return this.ltvPercent(home) < 75;
    },

    showNonDisclosureStateWarning: function showNonDisclosureStateWarning(home) {
      var nonDisclosureStates = ['AK', 'ID', 'KS', 'LA', 'MS', 'MO', 'MT', 'NM', 'ND', 'TX', 'UT', 'WY'];

      if (this.cma(home)) return false;

      var state = home.address.state;
      if (!state) return false;

      state = state.toUpperCase();

      return nonDisclosureStates.includes(state);
    },

    showRefiForFHA: function showRefiForFHA(home) {
      var maxLoan = this.maxLoan(home);
      return this.isFHA(home) && this.pmiRateForFHA(maxLoan);
    },

    showReverseMortgageSection: function showReverseMortgageSection(home) {
      return this.reverseMortgageEnabled(home) && this.reverseMortgageQualified(home);
    },

    showPmiSection: function showPmiSection(home) {
      var hasQualifyingLTV = moment().isBefore(home.metadata.ltvAutomatedDates['78']);

      if (!hasQualifyingLTV) {
        return false;
      }

      var hasConventionalPMI = this.conventionalPmiMonthlyTotal(home);

      if (hasConventionalPMI) {
        return true;
      }

      var agent = _.get(home, 'agent[0]', {});

      // HE-1770
      if (agent.type !== "realestate") {
        return false;
      }

      return this.hasLoanQualifyingForEstimatedPmi(home);
    },

    hasLoanQualifyingForEstimatedPmi: function hasLoanQualifyingForEstimatedPmi(home) {
      var currentLoans = this.currentLoans(home);
      var singleLoan = currentLoans.length === 1 && currentLoans[0];

      if (!home.soldPrice || !home.soldDate || !singleLoan) return false;

      if (moment(singleLoan.date).diff(moment(home.soldDate), 'months', true) > 3) return false;

      return !singleLoan.pmi_monthly && singleLoan.loan_type !== 'HELOC' && singleLoan.finance_type !== 'FHA' && !singleLoan.adjustable &&
      // Only show if we have available estimate data
      Boolean(this.estimatedPmiMonthlyTotal(home));
    },

    termHistory: function termHistory(home) {
      if (this.term(home) === 15) return 'FIX15YR';

      return 'FIX30YR';
    },

    termYears: function termYears(home) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.termYears || maxLoan.termYearsEstimated;

      return 30;
    },

    unverifiedLoans: function unverifiedLoans(home) {
      var THIS = this;
      return _.filter(home.loans, function (loan) {
        return loan.status === THIS.loanStatus && (!loan.termYears || !loan.rate);
      });
    },

    totalPaid: function totalPaid(home) {
      return home.soldPrice - this.outstandingPrincipalTotal(home);
    },

    monthsLeft: function monthsLeft(home) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return maxLoan.progress.payments_left;

      return 0;
    },

    yearsLeft: function yearsLeft(home) {
      var maxLoan = this.maxLoan(home);
      if (maxLoan) return Math.round(maxLoan.progress.payments_left / 12);

      return 0;
    }

  };
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = GlobalDictionary;
} else if (typeof window !== 'undefined') {
  window.GlobalDictionary = GlobalDictionary;
}

var Factory = function Factory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Factory);

  for (var k in options) {
    this[k] = options[k];
  }
};

if (typeof module !== 'undefined' && module.exports) module.exports = Factory;else if (typeof window !== 'undefined') window.Factory = Factory;

/*
* finance.js v0.1
* By: Trent Richardson [http://trentrichardson.com]
*
* Copyright 2012 Trent Richardson
* You may use this project under MIT or GPL licenses.
* http://trentrichardson.com/Impromptu/GPL-LICENSE.txt
* http://trentrichardson.com/Impromptu/MIT-LICENSE.txt

modified for homebot and node

*/

if (typeof window !== 'undefined' && window.moment) var moment = window.moment;else if (typeof require !== 'undefined') var moment = require('moment');

var finance = /** @exports finance */{

  version: '0.1',

  /*
  *	Defaults
  */
  settings: {
    format: 'number',
    formats: {
      USD: { before: '$', after: '', precision: 0, decimal: '.', thousand: ',', group: 3, negative: '-' }, // $
      GBP: { before: '£', after: '', precision: 2, decimal: '.', thousand: ',', group: 3, negative: '-' }, // £ or &#163;
      EUR: { before: '€', after: '', precision: 2, decimal: '.', thousand: ',', group: 3, negative: '-' }, // € or &#8364;
      percent: { before: '', after: '%', precision: 0, decimal: '.', thousand: ',', group: 3, negative: '-' },
      number: { before: '', after: '', precision: null, decimal: '.', thousand: ',', group: 3, negative: '-' },
      defaults: { before: '', after: '', precision: 0, decimal: '.', thousand: ',', group: 3, negative: '-' }
    }
  },

  defaults: function defaults(object, defs) {
    var key;
    object = object || {};
    defs = defs || {};

    for (key in defs) {
      if (defs.hasOwnProperty(key)) {
        if (object[key] == null) object[key] = defs[key];
      }
    }
    return object;
  },

  /*
  *	Formatting
  */

  // add a currency format to library
  addFormat: function addFormat(key, options) {
    this.settings.formats[key] = this.defaults(options, this.settings.formats.defaults);
    return true;
  },

  // remove a currency format from library
  removeFormat: function removeFormat(key) {
    delete this.settings.formats[key];
    return true;
  },

  // format a number or currency test
  format: function format(num, settings, override) {
    num = parseFloat(num);

    if (settings === undefined) settings = this.settings.formats[this.settings.format];else if (typeof settings == 'string') settings = this.settings.formats[settings];else settings = settings;
    settings = this.defaults(settings, this.settings.formats.defaults);

    if (override !== undefined) settings = this.defaults(override, settings);

    // set precision
    if (settings.precision != null) num = num.toFixed(settings.precision);

    var isNeg = num < 0,
        numParts = Math.abs(num).toString().split('.'),
        baseLen = numParts[0].length;

    // add thousands and group
    numParts[0] = numParts[0].replace(/(\d)/g, function (str, m1, offset, s) {
      return offset > 0 && (baseLen - offset) % settings.group == 0 ? settings.thousand + m1 : m1;
    });

    // add decimal
    num = numParts.join(settings.decimal);

    // add negative if applicable
    if (isNeg && settings.negative) {
      num = settings.negative[0] + num;
      if (settings.negative.length > 1) num += settings.negative[1];
    }

    return settings.before + num + settings.after;
  },

  /*
  *	Financing
  */

  //	calculate total of principal + interest (yearly) for x months
  calculateAccruedInterest: function calculateAccruedInterest(principal, months, rate) {
    var i = rate / 1200;
    return principal * Math.pow(1 + i, months) - principal;
  },

  //	determine the amount financed
  calculateAmount: function calculateAmount(finMonths, finInterest, finPayment) {
    var result = 0;

    if (finInterest == 0) {
      result = finPayment * finMonths;
    } else {
      var i = finInterest / 100 / 12,
          i_to_m = Math.pow(i + 1, finMonths),
          a = finPayment / (i * i_to_m / (i_to_m - 1));
      result = Math.round(a * 100) / 100;
    }

    return result;
  },

  calculateAPR: function calculateAPR(loanAmount, numPayments, baseRate, costs) {
    // based off of http://www.webmasterymadesimple.com/blog/javascript-function-for-calculating-annual-percentage-rate-a.html
    // loanAmount = the amount borrowed
    // numPayments = number of monthly payments e.g. 30 years = 360
    // baseRate = the base percentage rate of the loan. A 5.25% Annual Rate should be passed in as 0.0525 NOT 5.25
    // costs = the loan closing costs in dollars

    var rate = baseRate / 12;
    var totalMonthlyPayment = (loanAmount + costs) * rate * Math.pow(1 + rate, numPayments) / (Math.pow(1 + rate, numPayments) - 1);
    var testRate = rate;
    var iteration = 1;
    var testResult = 0;

    //iterate until result === 0
    var testDiff = testRate;
    while (iteration <= 100) {
      testResult = testRate * Math.pow(1 + testRate, numPayments) / (Math.pow(1 + testRate, numPayments) - 1) - totalMonthlyPayment / loanAmount;
      if (Math.abs(testResult) < 0.0000001) break;
      if (testResult < 0) testRate += testDiff;else testRate -= testDiff;
      testDiff = testDiff / 2;
      iteration++;
    }

    testRate = testRate * 12;
    testRate = testRate * 100; // convert to percentage
    return testRate.toFixed(6) / 1; // convert to float
  },

  //	determine the months financed
  calculateMonths: function calculateMonths(finAmount, finInterest, finPayment) {
    var result = 0;

    if (finInterest == 0) {
      result = Math.ceil(finAmount / finPayment);
    } else {
      result = Math.round(-1 / 12 * Math.log(1 - finAmount / finPayment * (finInterest / 100 / 12)) / Math.log(1 + finInterest / 100 / 12) * 12);
    }

    return result;
  },

  //	determine the interest rate financed http://www.hughchou.org/calc/formula.html
  calculateInterestRate: function calculateInterestRate(finAmount, finMonths, finPayment) {
    var result = 0;

    var min_rate = 0,
        max_rate = 100;
    while (min_rate < max_rate - 0.0001) {
      var mid_rate = (min_rate + max_rate) / 2,
          j = mid_rate / 1200,
          guessed_pmt = finAmount * (j / (1 - Math.pow(1 + j, finMonths * -1)));

      if (guessed_pmt > finPayment) {
        max_rate = mid_rate;
      } else {
        min_rate = mid_rate;
      }
    }
    return mid_rate.toFixed(2);
  },

  //	determine the payment
  calculatePayment: function calculatePayment(finAmount, finMonths, finInterest) {

    finInterest = parseFloat(finInterest);

    var result = 0;

    if (finInterest == 0) {
      result = finAmount / finMonths;
    } else {
      var i = finInterest / 100 / 12,
          i_to_m = Math.pow(i + 1, finMonths),
          p = finAmount * (i * i_to_m / (i_to_m - 1));
      result = Math.round(p * 100) / 100;
    }

    return result;
  },

  calculateFee: function calculateFee(finAmount, pts) {},

  calculateInterest: function calculateInterest(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly) {
    var payment = this.calculatePayment(finAmount, finMonths, finInterest),
        balance = finAmount,
        totalInterest = 0.0,
        isFuture = false,
        ep = 0,
        currInterest = null,
        currPrincipal = null,
        currDate = finDate ? new Date(finDate) : new Date();

    currDate.setMonth(currDate.getMonth() + 1);

    if (biWeekly) finMonths = finMonths / 12 * 26;

    for (var i = 0; i < finMonths; i++) {

      if (finExtraPay && ep === 0 && moment(currDate.getTime()).isAfter(new Date())) {
        isFuture = true;
        //don't calc payment unless its the future, not back dating extra payments
        if (finExtraPay) ep = biWeekly ? finExtraPay / 2 : finExtraPay;
      }

      currInterest = isFuture && biWeekly ? balance * finInterest / 2600 : balance * finInterest / 1200;
      totalInterest += currInterest;
      currPrincipal = isFuture && biWeekly ? payment / 2 - currInterest + ep : payment - currInterest + ep;
      balance -= currPrincipal;

      if (balance < 0) break;

      if (biWeekly) currDate = moment(currDate.getTime()).add(14, 'days')._d;else currDate.setMonth(currDate.getMonth() + 1);
    }

    return totalInterest;
  },

  calculateAmortization: function calculateAmortization(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly, endDate, extraPayments) {

    var payment = this.calculatePayment(finAmount, finMonths, finInterest),
        balance = finAmount,
        interest = 0.0,
        totalInterest = 0.0,
        totalPrincipal = 0.0,
        schedule = [],
        currInterest = null,
        currPrincipal = null,
        todayPrincipalPaid = null,
        todayInterestPaid = null,
        todayPrincipal = null,
        todayInterest = null,
        breakevenPayment = null,
        breakevenDate = null,
        isFuture = false,
        totalExtraPayments = 0,
        ep = 0,
        lastMonth = 0,
        endDate = !!endDate ? new Date(endDate) : new Date(),
        //used to calc total paid
    currDate = finDate ? new Date(finDate) : new Date();

    currDate.setMonth(currDate.getMonth() + 1);

    //a year is now 26 payments instead of 12
    if (biWeekly) finMonths = finMonths / 12 * 26;

    for (var i = 0; i < finMonths; i++) {
      //save what the Principal is now
      if (!todayPrincipalPaid && moment(currDate.getTime()).isAfter(endDate)) {
        todayPrincipalPaid = totalPrincipal;
        todayInterestPaid = totalInterest;
        todayPrincipal = currPrincipal;
        todayInterest = currInterest;

        isFuture = true;
        //don't calc payment unless its the future, not back dating extra payments
        if (finExtraPay) ep = biWeekly ? finExtraPay / 2 : finExtraPay;
      }

      /*
      Extra Payments logic [{ amount,start_date,end_date }]
      */
      if (extraPayments) {
        //reset ep
        ep = 0;

        for (var e = 0; e < extraPayments.length; e++) {
          //if extra payment date falls after current date and before enddate if exists then add amount to principal
          if (moment(currDate.getTime()).isAfter(new Date(extraPayments[e].start_date)) && !extraPayments[e].end_date || !!extraPayments[e].end_date && moment(currDate.getTime()).isBefore(new Date(extraPayments[e].end_date))) {
            if (isFuture && finExtraPay) ep = biWeekly ? finExtraPay / 2 : finExtraPay;
            ep += parseInt(extraPayments[e].amount, 10);
            totalExtraPayments += ep;
            break;
          } else {
            if (isFuture && finExtraPay) {
              ep = biWeekly ? finExtraPay / 2 : finExtraPay;
              totalExtraPayments += ep;
            }
          }
        }
      } else {
        totalExtraPayments += ep;
      }

      currInterest = isFuture && biWeekly ? balance * finInterest / 2600 : balance * finInterest / 1200;
      totalInterest += currInterest;
      currPrincipal = isFuture && biWeekly ? payment / 2 - currInterest + ep : payment - currInterest + ep;
      balance -= currPrincipal;
      totalPrincipal += currPrincipal;

      /*
      Break even logic, two reasons for this
      1. calc what a one-time will be to get the principal payment is more than interest payment
      2. calc date when principal payment is more than interest payment
      	If paying an extra payment, this should not be counted and must be removed from the currPrincipal since
      it was added above. This will tell us the date when we can stop paying an extra payment
      and have the principal payment more than the interest payment.
      */
      if (!breakevenPayment && currPrincipal - ep > currInterest) {
        breakevenPayment = finAmount - balance;
        breakevenDate = moment(currDate.getTime()).format("YYYY-MM-DD");
      }

      if (balance < 0) {
        lastMonth = i;
        break;
      }

      schedule.push({
        balance: balance,
        principal: totalPrincipal,
        interest: totalInterest,
        payment: biWeekly ? payment / 2 + ep / 2 : payment + ep,
        paymentToPrincipal: currPrincipal,
        paymentToInterest: currInterest,
        extraPayment: ep,
        date: moment(currDate.getTime()).format("YYYY-MM-DD")
      });

      if (biWeekly) currDate = moment(currDate.getTime()).add(14, 'days')._d;else currDate.setMonth(currDate.getMonth() + 1);
    }
    return { 'amount': parseFloat(finAmount),
      'rate': parseFloat(finInterest),
      'periods': parseFloat(finMonths),
      'periods_saved': lastMonth === 0 ? 0 : biWeekly ? finMonths - lastMonth / 26 * 12 : finMonths - lastMonth,
      'principal_paid': parseFloat(todayPrincipalPaid),
      'interest_paid': parseFloat(todayInterestPaid),
      'principal': parseFloat(totalPrincipal),
      'interest': parseFloat(totalInterest),
      'extra_payment_total': parseFloat(totalExtraPayments),
      'payment': {
        'total': parseFloat(payment),
        'principal': parseFloat(todayPrincipal),
        'interest': parseFloat(todayInterest)
      },
      'break_even_payment': parseFloat(breakevenPayment),
      'break_even_date': breakevenDate,
      'extra_payment': parseFloat(finExtraPay),
      'start_date': moment(finDate).format("YYYY-MM-DD"),
      'maturity_date': schedule[schedule.length - 1]['date'],
      'schedule': schedule
    };
  },

  getMaturityDate: function getMaturityDate(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly) {

    var amortization = this.calculateAmortization(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly);

    var maturity_date = amortization.schedule[amortization.schedule.length - 1]['date'];
    var interest = amortization.schedule[amortization.schedule.length - 1]['interest'];

    //update periods to reflect months since sold
    var soldDate = moment(finDate);
    finMonths = finMonths + soldDate.diff(moment(), 'months');

    //get time savings from amortization
    var date = moment(amortization.schedule[amortization.schedule.length - 1]['date']);
    var months_saved = finMonths - date.diff(moment(), 'months');

    return {
      'date': maturity_date,
      'months_left': finMonths - months_saved,
      'interest_paid': interest,
      'extra_paid': finExtraPay,
      'time_savings': {
        'years': parseInt(months_saved / 12, 10),
        'months': months_saved % 12
      }
    };
  }

};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = finance;
} else if (typeof window !== 'undefined') {
  window.finance = finance;
}

if (typeof require !== 'undefined' && typeof _ === 'undefined') var _ = require('lodash');

if (typeof require !== 'undefined' && typeof moment === 'undefined') var moment = require('moment');

if (typeof require !== 'undefined' && typeof numeral === 'undefined') var numeral = require('numeral');

var GlobalHelpers = {

  abbreviateMoney: function abbreviateMoney(number) {
    if (number > 100000 && number < 999999 || number > 100000000 && number < 999999999 || number > 100000000000 && number < 999999999999) {
      return numeral(number).format('$0a');
    }

    var formatted = numeral(number).format('$0.0a');

    return formatted.replace('.0', '');
  },

  dateFormat: 'YYYY-MM-DD',

  cleanUndefinedValues: function cleanUndefinedValues(obj) {
    return _.pick(obj, function (val) {
      return val !== undefined;
    });
  },

  clientNameDisplay: function clientNameDisplay(users) {
    if (!users || !users.length) return '';

    if (users.length === 1) return users[0].last_name + ', ' + users[0].first_name;

    if (users[0].last_name === users[1].last_name) return users[0].last_name + ', ' + users[0].first_name + ' & ' + users[1].first_name;else return users[0].last_name + ', ' + users[0].first_name + ' & ' + users[1].last_name + ', ' + users[1].first_name;
  },

  displayAddress: function displayAddress(address) {
    var unit = address.unit ? ' #' + address.unit : '';
    return '' + address.street + unit + ', ' + address.city + ', ' + address.state + ' ' + address.zip;
  },

  everyNth: function everyNth(arr, n) {
    if (n === 0) return arr;

    return _.filter(arr, function (i, v) {
      return v % n === 0;
    });
  },

  repeatArray: function repeatArray(val, len) {
    var a = [];
    for (var i = 0; i < len; i++) {
      a.push(val);
    };
    return a;
  },

  getAppreciationPercent: function getAppreciationPercent(avm, originalSoldPrice) {
    return Math.round((avm / originalSoldPrice - 1) * 100);
  },

  getFloatFromString: function getFloatFromString(str) {
    str = str || '';
    if (typeof str === 'number') return str;

    str = str.replace(/[^0-9.]/g, '');

    try {
      return parseFloat(str) || null;
    } catch (e) {
      throw 'Error parsing float from string.';
    }
  },

  getIntFromString: function getIntFromString(str) {
    str = str || '';

    if (typeof str === 'number') return str;

    str = str.replace(/,/g, '');

    try {
      return parseInt(str.match(/\d+/)[0], 10) || null;
    } catch (e) {
      throw 'Error parsing int from string.';
    }
  },

  sortByDate: function sortByDate(arr, date_field) {
    return _.sortBy(arr, function (obj) {
      if (!obj[date_field]) return -1;
      return -GlobalHelpers.formatDateForSort(obj[date_field]);
    });
  },

  currentLoanSort: function currentLoanSort(loan) {
    if (loan.loan_type === 'FIRST CEL') return -40;else if (loan.loan_type === 'SECOND CEL') return -30;else if (loan.loan_type === 'THIRD CEL') return -20;

    return -10;
  },

  sortByLoanType: function sortByLoanType(loans) {
    var sortedLoans = _.cloneDeep(loans);
    sortedLoans = GlobalHelpers.sortByDate(sortedLoans, 'date');
    return _.sortBy(sortedLoans, GlobalHelpers.currentLoanSort);
  },

  formatCurrency: function formatCurrency(val) {
    var val = parseFloat(val);
    return Math.round(val * 100) / 100;
  },

  formatDateForSort: function formatDateForSort(date) {
    return moment(date).format('YYYYMMDD');
  },

  formatPhone: function formatPhone(number, dashes) {
    number = number || '';
    var str = number.toString().replace(/[^0-9]/g, '');

    if (!str || str.length < 9) return '';

    if (!dashes) return parseInt(str, 10);

    if (str.slice(0, 1) === '1') str = str.slice(1);

    return str.slice(0, 3) + '-' + str.slice(3, 6) + '-' + str.slice(6);
  },

  homesFilter: function homesFilter(home, query) {
    var str = '';
    query = query || '';
    query = query.toLowerCase().trim();

    if (!query || query.length < 2) return true;

    _.each(home.users, function (user) {
      str += user.first_name + ' ' + user.last_name;
    });

    str += ' ' + home.address.street + ' ' + home.address.city;

    return str.toLowerCase().indexOf(query) !== -1;
  },

  homesUnsentFilter: function homesUnsentFilter(home) {
    var thirtyDaysAgo = moment().subtract(30, 'days').format('X');

    function where(event) {
      if (!event || event.source !== 'mandrill' || event.event !== 'sent' || moment(event.created).format('X') < thirtyDaysAgo) return false;else return true;
    };

    if (_.filter(home.activity, where).length < 1) return true;else return false;
  },

  homesNeedsCMAFilter: function homesNeedsCMAFilter(home) {
    return home.hasRequestedCMA && !home.agentAVM;
  },

  clientsFilter: function clientsFilter(client, query) {
    var str = '';
    query = query || '';
    query = query.toLowerCase().trim();

    if (!query || query.length < 2) return true;

    if (client.homes && client.homes.length > 0) {
      _.each(client.homes, function (home) {
        str += ' ' + home.address.street + ' ' + home.address.city;
      });
    }

    str += ' ' + client.first_name + ' ' + client.last_name;

    return str.toLowerCase().indexOf(query) !== -1;
  },

  isActiveFilter: function isActiveFilter(event) {
    return event.event === 'view';
  },

  isFalsey: function isFalsey(val) {
    // useful for parsing angular vals as true/false
    if (!val || parseInt(val) === 0 || val === 'false' || val === 'undefined') return true;else return false;
  },

  importFilter: function importFilter(user, query) {
    var str = '';
    query = query || '';
    query = query.toLowerCase().trim();

    if (!query || query.length < 2) return true;

    if (user.street && user.city) {
      str += ' ' + user.street + ' ' + user.city;
    }

    str += ' ' + user.first_name + ' ' + user.last_name;

    return str.toLowerCase().indexOf(query) !== -1;
  },

  parseAPIError: function parseAPIError(response) {
    if (response && response.data && response.data.error && response.data.error.message) return response.data.error.message;else if (response && response.data && response.data.error && response.data.error.details && response.data.error.details.messages) return _.map(response.data.error.details.messages, function (message, i) {
      return message[0];
    });else return 'An error has occurred.';
  },

  calcPeriods: function calcPeriods(years, loanStartDate, loanEndDate) {
    if (loanStartDate) {
      var date = moment(loanStartDate);
      if (loanEndDate) return years * 12 + date.diff(moment(new Date(loanEndDate)), 'months');else return years * 12 + date.diff(moment(), 'months');
    } else {
      return years * 12;
    }
  },

  getRateLookupType: function getRateLookupType(years, isAdjustable) {
    if (years === 30 && !isAdjustable) return 'FIX30YR';else if (years === 15 && !isAdjustable) return 'FIX15YR';else if (years === 5 && isAdjustable) return 'ARM5YR';else if (years === 1 && isAdjustable) return 'ARM1YR';

    return 'FIX30YR';
  },

  sortRealEstateAgents: function sortRealEstateAgents(agents) {
    return agents.sort(function (agent1, agent2) {
      var agent1count = agent1.homes ? agent1.homes.length : 0;
      var agent2count = agent2.homes ? agent2.homes.length : 0;

      // sort by number of homes
      if (agent1count < agent2count) return 1;else if (agent1count > agent2count) return -1;

      // then by first_name
      if (agent1.first_name < agent2.first_name) return -1;else if (agent1.first_name > agent2.first_name) return 1;else // nothing to split them
        return 0;
    });
  },

  calcMaturityDate: function calcMaturityDate(years, soldDate) {
    return moment(soldDate).add(years, 'years').format("YYYY-MM-DD");
  },

  getEmailMatchRegex: function getEmailMatchRegex(email) {
    var pattern = GlobalHelpers.escapeStringForRegex(email);
    return new RegExp('.*^' + pattern + '$.*', "i"); /* case-insensitive RegExp search */
  },

  escapeStringForRegex: function escapeStringForRegex(string) {
    // escapes special characters
    // $& means the whole matched string
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  },

  sortUsers: function sortUsers(users) {
    return _.chain(users).groupBy(function (user) {
      switch (user.borrowerType) {
        case 'borrower':
        case 'coborrower':
          return user.borrowerType;
        default:
          return 'other';
      }
    }).mapValues(function (group) {
      return group.sort(function (a, b) {
        return new Date(a.created) - new Date(b.created);
      });
    }).thru(function (userGroups) {
      return [userGroups.borrower, userGroups.coborrower, userGroups.other];
    }).compact().flatten().value();
  }
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = GlobalHelpers;
} else if (typeof window !== 'undefined') {
  window.Helpers = GlobalHelpers;
}

if (typeof require !== 'undefined') {
  var moment = require('moment');
  var finance = require('../lib/Finance.js');
}

var AirDnaChartSerializer = function () {
  function AirDnaChartSerializer() {
    _classCallCheck(this, AirDnaChartSerializer);
  }

  _createClass(AirDnaChartSerializer, null, [{
    key: 'monthlyRevenue',
    value: function monthlyRevenue(data) {
      var percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var monthlyValues = this._extractValues(data.revenue);

      var datapoints = Object.keys(monthlyValues).map(function (month) {
        var momentObj = moment().month(month - 1).date(1);
        var amount = monthlyValues[month] * percentage || 0;

        return {
          value: amount,
          date: momentObj.toDate(),
          tooltipEmphasis: '$' + finance.format(amount),
          tooltipDescription: momentObj.format('MMM') + ' Avg.'
        };
      });

      return { datapoints: datapoints, yFormat: 'money' };
    }
  }, {
    key: 'monthlyOccupancy',
    value: function monthlyOccupancy(data) {
      var percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var monthlyValues = this._extractValues(data.occupancy);

      var datapoints = Object.keys(monthlyValues).map(function (month) {
        var momentObj = moment().month(month - 1).date(1);
        var nights = Math.round(30 * monthlyValues[month] * percentage);

        return {
          value: nights,
          date: momentObj.toDate(),
          tooltipEmphasis: nights + ' Nights',
          tooltipDescription: momentObj.format('MMM') + ' Avg.'
        };
      });

      return { datapoints: datapoints };
    }
  }, {
    key: 'nightlyRate',
    value: function nightlyRate(data) {
      var percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var monthlyValues = this._extractValues(data.adr);

      var datapoints = Object.keys(monthlyValues).map(function (month) {
        var momentObj = moment().month(month - 1).date(1);
        var amount = monthlyValues[month] * percentage || 0;

        return {
          value: amount,
          date: momentObj.toDate(),
          tooltipEmphasis: '$' + finance.format(amount) + '/night',
          tooltipDescription: momentObj.format('MMM') + ' Avg.'
        };
      });

      return { datapoints: datapoints, yFormat: 'money' };
    }
  }, {
    key: '_extractValues',
    value: function _extractValues(yearlyValues) {
      yearlyValues = _.cloneDeep(yearlyValues);

      if (yearlyValues.ltm) delete yearlyValues.ltm;

      return this._flattenYears(yearlyValues);
    }
  }, {
    key: '_flattenYears',
    value: function _flattenYears(datapoints) {
      // Flatten into a single object with no year
      var monthlyValues = _.values(datapoints);
      return Object.assign(monthlyValues[0], monthlyValues[1]);
    }
  }]);

  return AirDnaChartSerializer;
}();

if (typeof module !== 'undefined' && module.exports) module.exports = AirDnaChartSerializer;else if (typeof window !== 'undefined') window.AirDnaChartSerializer = AirDnaChartSerializer;

// Add Authorization header to each request

angular.module('homebot.services').service('AuthHeaderInterceptor', ['SessionService', function (SessionService) {
  return {
    request: function request(config) {
      var authHeader = SessionService.getAuthHeader();

      if (authHeader) config.headers.Authorization = authHeader;

      return config;
    }
  };
}]);

angular.module('homebot.services').factory('NavDropdownService', ['$rootScope', function ($rootScope) {

  return {
    set: function set(dropdown) {
      if (dropdown) this.currentDropdown = dropdown;else this.currentDropdown = null;

      $rootScope.$broadcast('NavDropdownChange', {
        currentDropdown: this.currentDropdown
      });
    }
  };
}]);

angular.module('homebot.services').factory('RollbarService', ['Rollbar', 'APP_CONFIG', function (Rollbar, APP_CONFIG) {
  function logMessage(message, data) {
    console.log('Message sent to rollbar:', message, data);
  };

  return {
    error: function error(message) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!APP_CONFIG.ROLLBAR_ENV) return logMessage(message, data);

      // Data can be a JS Error instance
      Rollbar.error(message, data);
    },

    info: function info(message) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!APP_CONFIG.ROLLBAR_ENV) return logMessage(message, data);

      Rollbar.info(message, data);
    }
  };
}]);

angular.module('homebot.services').factory('ScrollService', ['$rootScope', function ($rootScope) {
  return {
    subscribe: function subscribe(scope, callback) {
      var handler = $rootScope.$on('scroll-event', function (e, data) {
        callback(e, data);
      });

      scope.$on('$destroy', handler);
    },

    scroll: function scroll(data) {
      $rootScope.$emit('scroll-event', data);
    }
  };
}]);

angular.module('homebot.services').service('SessionService', ['$cookies', function ($cookies) {
  var service = {
    getAuthHeader: function getAuthHeader() {
      var token = service.getLockboxToken();

      if (token) return 'Bearer ' + token;

      var nodeToken = service.getNodeToken();

      if (nodeToken) return nodeToken;

      var homeownerToken = service.getHomeownerToken();

      if (homeownerToken) return homeownerToken;

      return null;
    },
    extractJWT: function extractJWT() {
      try {
        var jwt = service.getLockboxToken();
        return JSON.parse(atob(jwt.split('.')[1]));
      } catch (e) {
        return null;
      }
    },
    isParagonUser: function isParagonUser() {
      var jwt = service.extractJWT();
      var matchParagon = /^sso:paragon(:){0,1}/;
      var matchLegacyParagon = /^sso:pgnimp(:){0,1}/;

      return jwt && (matchParagon.test(jwt.kind) || matchLegacyParagon.test(jwt.kind));
    },
    isAgent: function isAgent() {
      if (service.getLockboxToken() || service.getNodeToken()) return true;

      return false;
    },
    isImpersonating: function isImpersonating() {
      var jwt = service.extractJWT();
      return jwt && jwt.kind === 'homebot:imp';
    },
    getLockboxCookie: function getLockboxCookie() {
      return $cookies.getObject('homebot-session-cookie');
    },
    getLockboxToken: function getLockboxToken() {
      var cookie = service.getLockboxCookie();

      if (cookie && cookie.authenticated && cookie.authenticated.access_token) return cookie.authenticated.access_token;

      return null;
    },
    getNodeToken: function getNodeToken() {
      var agentCookie = $cookies.getObject('agent');

      return agentCookie ? agentCookie.access_token : null;
    },
    getHomeownerToken: function getHomeownerToken() {
      return $cookies.get('accessToken') || null;
    },
    isLoggedIn: function isLoggedIn() {
      return Boolean(service.getLockboxToken() || service.getNodeToken());
    },
    clear: function clear() {
      // TODO : clear intercom
      $cookies.putObject('agent', null, { path: '/' });
      $cookies.remove('agent', { path: '/' });
      return Promise.resolve();
    }
  };

  return service;
}]);

angular.module('homebot.services').service('SSOService', ['$http', 'APP_CONFIG', 'RollbarService', 'SessionService', function ($http, APP_CONFIG, RollbarService, SessionService) {
  return {
    lockboxWhoami: function lockboxWhoami(includeParams) {
      var params = {};

      if (!SessionService.getLockboxToken()) return Promise.resolve(undefined);

      if (includeParams) params.include = includeParams;

      return $http.get(APP_CONFIG.SSO_API_URL + 'users/whoami', { params: params }).then(function (user) {
        return user;
      }).catch(function (e) {
        RollbarService.error('Lockbox Whoami error', e);
      });
    }
  };
}]);

if (typeof require !== 'undefined') {
  var Helpers = require('../Helpers.js');
  var moment = require('moment');
}

// This all needs to move to a require / module style
var LoanFormParser = {
  parse: function parse(rawLoan) {
    var loan = {
      amount: Helpers.getFloatFromString(rawLoan.amount),
      date: LoanFormParser._prepareDate(rawLoan),
      loan_type: rawLoan.loan_type,
      pmi_monthly: rawLoan.pmi_monthly,
      rate: rawLoan.rate,
      status: rawLoan.status || 'current'
    };

    if (loan.loan_type === 'HELOC') return loan;

    if (LoanFormParser._isAdjustable(rawLoan)) return LoanFormParser._addAdjustableProperties(loan, rawLoan);

    return LoanFormParser._addFixedProperties(loan, rawLoan);
  },

  parseForEditing: function parseForEditing(mortgage) {
    var loan = _.cloneDeep(mortgage);
    loan.pmi_monthly = loan.pmi_monthly && parseFloat(loan.pmi_monthly);
    loan.year = moment(loan.date).format('YYYY');
    loan.month = moment(loan.date).format('MMMM');
    loan.term = LoanFormParser.createTerm(loan);
    loan.rate = loan.rate || loan.rateEstimated;

    return loan;
  },

  createTerm: function createTerm(loan) {
    if (loan.adjustable) return 'ARM' + (loan.arm_years_initial || 5) + 'YR';else return 'FIX' + (loan.termYears || loan.termYearsEstimated) + 'YR';
  },

  _addAdjustableProperties: function _addAdjustableProperties(loan, rawLoan) {
    loan.adjustable = true;
    loan.arm_years_initial = Helpers.getIntFromString(rawLoan.term);
    return loan;
  },

  _addFixedProperties: function _addFixedProperties(loan, rawLoan) {
    loan.adjustable = false;
    loan.termYears = Helpers.getIntFromString(rawLoan.term);
    return loan;
  },

  _isAdjustable: function _isAdjustable(loan) {
    return loan.term.indexOf('ARM') !== -1;
  },

  _prepareDate: function _prepareDate(loan) {
    return moment().year(loan.year).month(loan.month).date(1).format(Helpers.dateFormat);
  }
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = LoanFormParser;
} else if (typeof window !== 'undefined') {
  window.LoanFormParser = LoanFormParser;
}